import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import loader from "../../assets/Images/loader.gif";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import Swal from "sweetalert2";
import imageCompression from "browser-image-compression";
import * as api from "../../api_function";


const password = sessionStorage.getItem('password');
const userName = sessionStorage.getItem('userName');
// const userName2 = sessionStorage.getItem('userName');
const userName2 = "manager1";


const optionPayment = [
  { label: "Online", value: "Online" },
  { label: "Offline", value: "Offline" },
]

const genderOptions = [
  { label: "Select Option", value: "" },
  { label: "Male", value: "111260000" },
  { label: "Female", value: "111260001" },
]

const optionState = [
  { name: "Select State", code: "" },
  { name: "Andhra Pradesh", code: "100009" },
  { name: "Jharkhand", code: "100030" },
  { name: "Bihar", code: "100021" },
  { name: "Delhi", code: "100004" },
  { name: "Gujarat", code: "100015" },
  { name: "Haryana", code: "100008" },
  { name: "Jammu and Kashmir", code: "100011" },
  { name: "Karnataka", code: "100007" },
  { name: "Kerala", code: "100012" },
  { name: "Madhya Pradesh", code: "100014" },
  { name: "Maharashtra", code: "100002" },
  { name: "Odisha", code: "100026" },
  { name: "Other*", code: "100017" },
  { name: "Punjab", code: "100025" },
  { name: "Rajasthan", code: "100010" },
  { name: "Tamil Nadu", code: "100003" },
  { name: "Telangana", code: "100023" },
  { name: "Uttar Pradesh", code: "100006" },
  { name: "Uttarakhand", code: "100016" },
  { name: "West Bengal", code: "100013" },
  { name: "Goa", code: "100028" },
];

const firmtypeOpts = [
  { value: "0", label: "Select Firm Type" },
  { value: "1", label: "Proprietorship" },
  { value: "2", label: "Partnership" },
  { value: "3", label: "Pvt Ltd" },
  { value: "4", label: "Ltd" },
  { value: "5", label: "Trust" },
  { value: "6", label: "Individual" },
  { value: "7", label: "LLP" },
];

const SecuritypeOpts = [
  { value: "", label: "Select Option" },
  { value: "1", label: "Refundable Security Deposit" },
  { value: "2", label: "Non-Refundable Security Deposit" },
];

const optionDocument = [
  // { label: "AADHAR", value: "AADHAR" },
  { label: "COI", value: "CIN" },
  { label: "GST", value: "GST" },
  { label: "DL", value: "LICENCE" },
  { label: "PAN", value: "PAN" },
  // { label: "Voter ID", value: "VOTERID" },
  { label: "MCA", value: "MCA" },
];

const PaymentOpts = [
  { value: "0", label: "Select Option" },
  { value: "111260000", label: "Payment Validation Failed" },
  { value: "111260001", label: "Upfront approved amount and Customer Paid Amount Mismatch" },
  { value: "569480002", label: "Pending" },
  { value: "569480000", label: "Payment Not Received" },
  { value: "569480001", label: "Payment Received" },
];

const payslipOpts = [
  { value: "0", label: "Select Option" },
  { value: "5", label: "RTGS" },
  { value: "1", label: "Cheque" },
  { value: "2", label: "Demand draft" },
  // { value: "7", label: "Credit Card" },
  // { value: "4", label: "NEFT" },
  // { value: "8", label: "Debit Card" },
  // { value: "11", label: "Ezetap" },
  // { value: "12", label: "Ezetap-Cheque" },
  { value: "13", label: "Payment Gateway" },
];

const optionCountry = [{ label: "India", value: "10001" }];
const optionNatinality = [
  { label: "Select Option", value: "0" },
  { label: "Indian", value: "1" },
  { label: "Korean", value: "3" },
  { label: "Other", value: "2" }
];

const optionAuthState = [
  { name: "Select State", code: "" },
  { name: "Andhra Pradesh", code: "100009" },
  { name: "Bihar", code: "100021" },
  { name: "Delhi", code: "100004" },
  { name: "Gujarat", code: "100015" },
  { name: "Haryana", code: "100008" },
  { name: "Jammu and Kashmir", code: "100011" },
  { name: "Karnataka", code: "100007" },
  { name: "Kerala", code: "100012" },
  { name: "Madhya Pradesh", code: "100014" },
  { name: "Maharashtra", code: "100002" },
  { name: "Odisha", code: "100026" },
  { name: "Other*", code: "100017" },
  { name: "Punjab", code: "100025" },
  { name: "Rajasthan", code: "100010" },
  { name: "Tamil Nadu", code: "100003" },
  { name: "Telangana", code: "100023" },
  { name: "Uttar Pradesh", code: "100006" },
  { name: "Uttarakhand", code: "100016" },
  { name: "West Bengal", code: "100013" },
  { name: "Goa", code: "100028" },
];

const SalutationOpts = [
  { value: "0", label: "Select Option", isDisabled: false },
  { value: "1", label: "Mr." },
  { value: "2", label: "Mrs." },
  { value: "3", label: "Miss." },
];


const BroadbandCAFmanageForm = () => {

  const style = {
    control: (base) => ({
      ...base,
      border: 0,
      // Remove box shadow
      boxShadow: "none",
      backgroundColor: "transparent",
      color: "black",
    }),
  };
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const CafId = searchParams.get("CafId");
  const leadId = searchParams.get("leadId");
  const OppId = searchParams.get("OppId");

  sessionStorage.setItem("OppId", OppId);
  // console.log("leadId", leadId);
  // console.log("OppId", OppId);

  const navigate = useNavigate();
  const fileInputRef = useRef(null);
  const [activeForm, setActiveForm] = useState("form1");
  const [loading, setLoading] = useState(true);
  const [paymentDetails, setPaymentDetails] = useState({});
  const [salutate, setSalutate] = useState();
  const [gender, setGender] = useState();
  const [mobileNo, setMobileNo] = useState();

  const [Caflatitude, setCaflatitude] = useState();
  const [Caflongitude, setCaflongitude] = useState();

  const [emailId, setEmailId] = useState();
  const [billingEmailId, setBillingEmailId] = useState();
  const [techSupportEmail, setTechSupportEmailId] = useState();

  const [companyOptions, setCompanyOptions] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [groupOptions, setGroupOptions] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectRelationship, setSelectRelationship] = useState("");
  const [relationshipOptions, setRelationshipOptions] = useState([]);
  const [selectCity, setSelectCity] = useState("");
  const [cityType, setCityType] = useState([]);
  const [selectState, setSelectState] = useState("");
  const [areaList, setAreaList] = useState([]);
  const [selectArea, setSelectArea] = useState("");
  const [societyList, setSocietyList] = useState([]);
  const [selectSociety, setSelectSociety] = useState("");

  const [selectedFirmType, setSelectedFirmType] = useState();
  const [firmTypes, setFirmTypes] = useState([]);
  const [productdropdetails, setProductdropdetails] = useState([]);
  const [selectedProductType, setSelectedProductType] = useState();
  const [firstName, setFirstName] = useState();

  const [leadName, setLeadName] = useState();
  const [lastName, setLastName] = useState();
  const [Voice, setVoice] = useState();
  const [Securitydep, setSecuritydep] = useState("");
  const [Securitydeptype, setSecuritydeptype] = useState("");
  const [transactionrefid, settransactionrefid] = useState("");
  const [approvalCode, setapprovalCode] = useState("");
  const [creditDetails, setcreditDetails] = useState("");
  const [debitDetails, setDebitDetails] = useState("");
  const [chequeDDNo, setchequeDDNo] = useState("");
  const [branchName, setbranchName] = useState("");
  const [chequeDate, setchequeDate] = useState("");
  const [selectedPaySlipOption, setselectedPaySlipOption] = useState("");
  const [BankDropDetails, setBankDropDetails] = useState([]);
  const [selectBank, setselectBank] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [GstNumber, setGstNumber] = useState("");


  const [apiFloorCode, setApiFloorCode] = useState("");
  const [apipinCode, setApiPinCode] = useState("");
  const [apiblockCode, setApiblockCode] = useState("");
  const [floor, setFloor] = useState("");


  const [OtpValue, setOtpValue] = useState();
  const [OtpValue2, setOtpValue2] = useState();

  const [otpAuthStatus, setotpAuthStatus] = useState();
  const [paymentStatus, setpaymentStatus] = useState(PaymentOpts[0]);


  const [tan, setTan] = useState();
  const [pan, setPan] = useState();
  const [leadDisable, setLeadDisable] = useState(false);

  const [selectKycDoc, setSelectKycDoc] = useState("");
  const [getKycDocBase, setGetKycDocBase] = useState("");
  const [customerImg, setCustomerImg] = useState("")


  const [selectAuthCountry, setSelectAuthCountry] = useState(optionCountry[0]);

  const [selectAuthState, setSelectAuthState] = useState("");
  const [cityAuthOption, setCityAuthOption] = useState([]);
  const [selectAuthCity, setSelectAuthCity] = useState("");

  const [getPaymentDOAFlag, setPaymentDOAFlag] = useState(false);
  const [getDedupeDOAFlag, setDedupeDOAFlag] = useState(false);
  const [getCustomerImageStatus, setCustomerImageStatus] = useState(null);


  const [userdata, setUserData] = useState({
    Remarks: "",
    Redunancy: false,
    Block: "",
    Status: "",
    Statuscode: "",
    OppId: "",
    LeadId: "",
    PriceList: "",
    Topic: "",
    StateId: "",
    CityId: "",
    AreaId: "",
    BuildingId: "",
    SpecificArea: "",
    SpecificBuilding: "",
    Building_BuildingStatus: "",
    NoOfUsers: "",
    NoOfBeds: "",
    IndustryId: "",
    ApprovalRequiredFlag: "",
    Reason: "",
    Area: "",
    Subbusinesssegment: "",
    Businesssegment: "",
    State: "",
    Salutation: "",
    Relationship: "",
    PostalCode: "",
    Mobilephone: "",
    Media: "",
    Lco: null,
    Industry: "",
    Group: "",
    Floor: "",
    TPFeasibilty: "",
    CreateAreaOrBuilding: false,
    Firmtype: "",
    Product: "",
    ProductSegment: "",
    FeasibilityRequired: false,
    Existingprovider: "",
    Emailaddress: "",
    Country: "",
    Companyname: "",
    City: "",
    leadname: "",
    Buildingname: "",
    BuildingNo: "",
    ContactPerson: "",
    CustomerSegment: "",
    LastMileType: "",
    UpTimesla: "",
    Firewall: "",
    CompanySelf: "",
    PoLock: "",
    Price: "",
    OriginatingLead: "",
    FirewallAwc: "",
    PoNext: "",
    Company: "",
    TotalAmount: "",
    VerticalID: "",
    TypeOfOrder: "",
    PocClosureDate: "",
    TurnOver: "",
    SocietyName: "",
    SocietyId: "",
    SocietyStatus: "",
    HousePlotFlatNo: "",
    BlockTowerNumber: "",
    OTCAmount: "",
    SDAmount: "",
    RCAmount: "",
    IsPaymentLinkSendToCustomer: "",
    UpfrontApprovedSDAmount: "",
    UpfrontApprovedOTCAmount: "",
    UpfrontApprovedRCAmount: "",
    UpfrontReqSDAmount: "",
    UpfrontReqOTCAmount: "",
    UpfrontReqRCAmount: "",
    ApprovedSDAmount: "",
    ApprovedOTCAmount: "",
    ApprovedRCAmount: "",
    totalAmount: "",
    firstName: "",
    otp: "",
    dDupStatus: "",
    paymentDoaStatus: "",
    authName: "",
    authFatherName: "",
    authResidentialAdd: "",
    authMobile: "",
    authPhone: "",
    authEmail: "",
    authPinCode: "",
    gstNo: "",
    panNo: "",
    tanNo: "",
  });
  const [paymentButton, setPaymentButton] = useState("");
  //naveen
  const [getCafDigiHome, setCafDigiHome] = useState({});
  const [isTimerActive, setIsTimerActive] = useState(false);
  const [timer, setTimer] = useState(0);
  const [getCodeFlag, setCodeFlag] = useState(false);
  const [getCustomerPicture, setCustomerPicture] = useState({});
  const [getSellerPicture, setSellerPicture] = useState({});
  const [getSelectDocumentType, setSelectDocumentType] = useState();
  // const [getCafId, setCafId] = useState();
  const [getLeadId, setLeadId] = useState();
  const [selectDocument, setSelectDocument] = useState();
  const [getNewCafUpdateRequestBody, setNewCafUpdateRequestBody] = useState({
    customerKYCdocument: {
      customerKYCfileNameWithExtension: "",
      customerKYCAddress: "",
      customerKYCfileContent: "",
    },
  });
  const [industrydropdetails, setindustrydropdetails] = useState([]);
  const [selectIndustry, setSelectIndustry] = useState();

  const [isOtpVerified, setOtpVerified] = useState(null);
  const [kycDocStatus, setKycDocStatus] = useState("");
  const [selectPaymentMode, setSelectPaymentMode] = useState()
  const [isPaymentLinkSendToCustomer, setIsPaymentLinkSendToCustomer] = useState("")
  // const [selectedPaymentMode, setSelectedPaymentMode] = useState(null);
  const [filteredPayslipOpts, setFilteredPayslipOpts] = useState(payslipOpts);





  const handleSelectAuthCountry = (selectCountry) => {
    setSelectAuthCountry(selectCountry);
  };



  const handleSelectAuthState = (selectedState) => {
    setSelectAuthState(selectedState);
    setSelectAuthCity("");
  };

  const handleSelectAuthCity = (selectedOption) => {
    setSelectAuthCity(selectedOption);
  };

  useEffect(() => {
    const fetchCities = async () => {
      try {
        // City API call
        const cityApiUrl = process.env.REACT_APP_API_URL;
        const cityRequestBody = {
          Action: "getCity",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          password: sessionStorage.getItem('password'),
          stateCode: selectAuthState.value,
          userName: sessionStorage.getItem('userName'),
        };
        const cityResponse = await fetch(cityApiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(cityRequestBody),
        });
        const cityData = await cityResponse.json();

        if (cityData.Response && Array.isArray(cityData.Response.Data)) {

          const transformedOptions = cityData.Response.Data.map(
            (option) => ({
              label: option.CityName,
              value: option.CityCode,
            })
          );
          setCityAuthOption(transformedOptions);

          // setCityAuthOption(cityData.Response.Data);
        } else {
          // console.error(
          //   "City data structure not recognized:",
          //   cityData.Response
          // );
          setCityAuthOption([]);

        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    // Fetch cities only if a state is selected
    if (selectAuthState) {
      fetchCities();
    }
  }, [selectAuthState]);

  const handlePaymentMode = (selectedOption) => {
    setSelectPaymentMode(selectedOption); // Update selected payment mode
    setselectedPaySlipOption("");
    if (selectedOption?.value === "Offline") {
      // Show only Cheque, DD, NEFT, RTGS
      setFilteredPayslipOpts(
        payslipOpts.filter((option) =>
          ["1", "2", "4", "5"].includes(option.value)
        )
      );
    } else if (selectedOption?.value === "Online") {
      // Show all options except Cheque, DD, NEFT, RTGS
      setFilteredPayslipOpts(
        payslipOpts.filter(
          (option) => !["1", "2", "4", "5"].includes(option.value)
        )
      );
    } else {
      // Reset to show all options if no valid payment mode is selected
      setFilteredPayslipOpts(payslipOpts);
    }
  };


  // const handlePaymentMode = (select) => {
  //   setSelectPaymentMode(select);
  // }
  const handleChange = (e) => {
    const { name, value, type } = e.target;
    setUserData((prevData) => ({
      ...prevData,
      [name]: type === "number" ? String(value) : value,
    }));
  };

  const yyyymmddFormat = (dateStr) => {
    if (!dateStr) return "";
    const parts = dateStr.split("-");
    if (parts.length !== 3) return "";
    if (parts[0].length === 4) {
      return dateStr; // Already in YYYY-MM-DD format
    } else {
      // Convert from DD-MM-YYYY to YYYY-MM-DD
      return `${parts[2]}-${parts[1]}-${parts[0]}`;
    }
  };

  useEffect(() => {
    // Get the current URL's query parameters
    const params = new URLSearchParams(window.location.search);
    const CafId = params.get("CafId");
    const LeadId = params.get("LeadId");
    // console.log("CafId", CafId, LeadId);
    // setCafId(CafId)
    setLeadId(LeadId)
  }, []);

  useEffect(() => {
    const fetchGetIndustry = async () => {
      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
          Action: "getindustrytype",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          areaCode: "",
          areaName: "",
          password: sessionStorage.getItem("password"),
          userName: sessionStorage.getItem("userName"),
        };

        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });

        const result = await response.json();
        if (result.Status == "Success") {
          const industryType = result.Response.map(
            (option) => ({
              label: option.IndTypeName,
              value: option.IndTypeId,
            })
          );
          setindustrydropdetails(industryType);
        }
      } catch (error) {
        console.error("Error fetching data:", error.message);
      } finally {

      }
    };

    fetchGetIndustry();
  }, []);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const firmTypeApiUrl = process.env.REACT_APP_API_URL;
        const firmTypeRequestBody = {
          Action: "firmTypeList",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          userName: sessionStorage.getItem("userName"),
          password: sessionStorage.getItem("password")
        }
        const firmTypeResponse = await fetch(firmTypeApiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(firmTypeRequestBody),
        });
        const firmTypeData = await firmTypeResponse.json();
        // console.log("firmTypeData.Response.Data", firmTypeData.Response.Data);

        if (firmTypeData.Response.Data) {

          const transformedOptions = firmTypeData.Response.Data.map(
            (option) => ({
              label: option.Text,
              value: option.Value,
            })
          );
          setFirmTypes(transformedOptions);
          // console.log("transformedOptions",transformedOptions)
        } else {
          setFirmTypes([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = `${today.getMonth() + 1}`.padStart(2, "0");
    const day = `${today.getDate()}`.padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const formatDateString = (dateString) => {
    if (!dateString) {
      return ""; // or any default value you prefer
    }

    const [day, month, year] = dateString.split("-");
    // Assuming dateString is in the format DD-MM-YYYY
    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    setSelectedDate(formatDateString(paymentDetails.PaymentDate));
    setchequeDate(formatDateString(paymentDetails.ChequeDDDate))
  }, [paymentDetails.PaymentDate, paymentDetails.ChequeDDDate]);

  const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };





  const handleIconClick = (formId) => {
    setActiveForm((prevActiveBox) =>
      prevActiveBox === formId ? null : formId
    );
  };

  const [checkboxes, setCheckboxes] = useState({
    Votercard: false,
    Passport: false,
    TelephoneBill: false,
    WaterBill: false,
    GasConnection: false,
    CentralStateGovtId: false,
    DrivingLicense: false,
    RentAgreement: false,
    ElectricityBill: false,
    AadharCard: false,
    CreditCardStatement: false,
    BankPassbook: false,
    RationCardPhotoId: false,
    PanCardPhotoId: false,
    AadharCardPhotoId: false,
    PassportPhotoId: false,
    CentralStateGovtIdPhotoId: false,
    VotercardPhotoId: false,
    DrivingLicensePhotoId: false,
    // check19:false,
  });



  const SendLinkForCustomerLivePicture = async () => {
    try {
      let CustomerLink;
      if (CafId) {
        CustomerLink = window.location.origin + "/crm/businessCustomerLivePhoto/?CafId=" + btoa(CafId);
      } else {
        CustomerLink = window.location.origin + "/crm/businessCustomerLivePhoto/?OppId=" + btoa(OppId);
      }
      // console.log(CustomerLink);

      const req = { OppId: OppId || "", CafID: CafId, CustomerLink: CustomerLink }
      const sendlink = await api.sendCustomerLiveImageURL(req);
      // console.log(sendlink);
      if (sendlink.Status == "Success") {
        toast.success("Link Sent to customer!")
      } else {
        toast.warning("Faild to send link!")
      }

    } catch (err) {
      console.error(err);
    }
  }


  const redirectBroadbandCafPage = () => {
    navigate("/broadbandCaf");
  };



  const handleSAlutation = (selectedOption) => {
    // console.log("salutate", selectedOption.value);
    setSalutate(selectedOption.value);
  };

  const handleGender = (selectedOption) => {
    // console.log("salutate", selectedOption.value);
    setGender(selectedOption.value);
  };





  //naveen
  const handleCustomerdetailChange = (event) => {
    const { name, value } = event.target;
    // console.log(name, " - ", value);


    if (name == 'firstName') {
      setCafDigiHome((prevState) => ({
        ...prevState, // Copy the previous state
        accountDetail: {
          ...prevState.accountDetail, // Copy the existing detail object
          FirstName: "", // Update the name property
        },
      }));
      setFirstName(value);
    } else if (name == 'lastName') {
      setCafDigiHome((prevState) => ({
        ...prevState, // Copy the previous state
        accountDetail: {
          ...prevState.accountDetail, // Copy the existing detail object
          LastName: "", // Update the name property
        },
      }));
      setLastName(value);
    } else if (name == 'mobileNo') {
      setCafDigiHome((prevState) => ({
        ...prevState, // Copy the previous state
        accountDetail: {
          ...prevState.accountDetail, // Copy the existing detail object
          MobileNo: "", // Update the name property
        },
      }));
      setMobileNo(value);
    } else if (name == 'emailId') {
      setCafDigiHome((prevState) => ({
        ...prevState,
        accountDetail: {
          ...prevState.accountDetail,
          EmailId: "",
        },
      }));
      setEmailId(value);
    }
    else if (name == 'leadname') {
      setCafDigiHome((prevState) => ({
        ...prevState,
        accountDetail: {
          ...prevState.accountDetail,
          leadname: "",
        },
      }));
      setLeadName(value);
    } else if (name == 'billingEmailId') {
      setCafDigiHome((prevState) => ({
        ...prevState,
        accountDetail: {
          ...prevState.accountDetail,
          BillingEmailId: "",
        },
      }));
      setBillingEmailId(value);
    } else if (name == 'techSupportEmail') {
      setCafDigiHome((prevState) => ({
        ...prevState,
        accountDetail: {
          ...prevState.accountDetail,
          techSupportEmail: "",
        },
      }));
      setTechSupportEmailId(value);
    }

    else if (name == 'cafNo') {
      // setCafDigiHome((prevState) => ({
      //   ...prevState,
      //   accountDetail: {
      //     ...prevState.accountDetail,
      //     EmailId: "",
      //   },
      // }));
      // setCafNO(value);
    } else if (name == 'voice') {
      // setCafDigiHome((prevState) => ({
      //   ...prevState,
      //   accountDetail: {
      //     ...prevState.accountDetail,
      //     EmailId: "",
      //   },
      // }));
      // setVoice(value);
    } else if (name == 'livePicture') {
      // setCafDigiHome((prevState) => ({
      //   ...prevState,
      //   accountDetail: {
      //     ...prevState.accountDetail,
      //     EmailId: "",
      //   },
      // }));
      // setVoice(value);
    }
  };



  const fetchCompanyData = async () => {
    try {
      setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestBody = {
        Action: "getCompany",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        companyId: "New Company",
        password: sessionStorage.getItem('password'),
        userName: sessionStorage.getItem('userName'),
      };

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      const data = await response.json();
      //console.log("conpany name :", data.Response.Data);
      if (data.Status === "Success" && data.StatusCode === "200") {
        return data.Response.Data.map((company) => ({
          label: company.Company_Name,
          value: company.Company_ID,
          group: company.Group_Name,
          groupId: company.Group_ID,
        }));
      } else {
        console.error("Error in API response:", data);
        return [];
      }
    } catch (error) {
      console.error("Error fetching company data:", error);
    } finally {
      setLoading(false);
    }
    return [];
  };


  useEffect(() => {
    const loadOptions = async () => {
      const options = await fetchCompanyData("");
      setCompanyOptions(options);
    };
    loadOptions();
  }, []);

  const handleCompanyChange = (selectedOption) => {
    setSelectedCompany(selectedOption);
  };

  useEffect(() => {
    // Update group options when selectedCompany changes
    if (selectedCompany) {
      setGroupOptions([
        { label: selectedCompany.group, value: selectedCompany.groupId },
      ]);
    } else {
      setGroupOptions([]);
    }
  }, [selectedCompany]); // Only trigger the effect when selectedCompany changes


  const fetchRelationshipData = async (companyId) => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestBody = {
        Action: "getRelationship",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        companyId: companyId,
        password: sessionStorage.getItem("password"),
        userName: sessionStorage.getItem("userName"),
      };
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      const data = await response.json();
      if (data.Status === "Success" && data.StatusCode === "200") {
        return data.Response.Data.map((relationship) => ({
          label: relationship.Relationship_Name,
          value: relationship.Relationship_ID,
        }));
      } else {
        console.error("Error in API response:", data);
        return [];
      }
    } catch (error) {
      console.error("Error fetching relationship data:", error);
    }
    return [];
  };

  useEffect(() => {
    const loadRelationships = async () => {
      // console.log("selectedCompany",selectedCompany);
      if (selectedCompany) {
        const relationshipOptions1 = await fetchRelationshipData(
          selectedCompany.value
        );
        // console.log("relationshipOptions1",relationshipOptions1);
        setRelationshipOptions(relationshipOptions1);
      }
    };
    loadRelationships();
  }, [selectedCompany]);

  const handleSelectState = (selectedState) => {
    setSelectState(selectedState);
  };

  useEffect(() => {
    const fetchCities = async () => {
      try {
        // City API call
        const cityApiUrl = process.env.REACT_APP_API_URL;
        const cityRequestBody = {
          Action: "getCity",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          password: sessionStorage.getItem("password"),
          stateCode: selectState.value,
          userName: sessionStorage.getItem("userName"),
        };
        const cityResponse = await fetch(cityApiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(cityRequestBody),
        });
        const cityData = await cityResponse.json();

        if (cityData.Response && Array.isArray(cityData.Response.Data)) {
          setCityType(cityData.Response.Data);
          // setSelectArea([]);
        } else {
          console.error(
            "City data structure not recognized:",
            cityData.Response
          );
          setCityType([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    // Fetch cities only if a state is selected
    if (selectState) {
      fetchCities();
    }
  }, [selectState]);

  const handleSelectCity = async (selectedOption) => {
    const selectedCityCode = selectedOption ? selectedOption.value : "";
    const selectedCityName = selectedOption ? selectedOption.label : "";
    // console.log("selectedCityCode", selectedOption.value);
    // console.log("selectedCityName", selectedOption.label);
    setSelectCity(selectedOption);
    try {
      const areaApiUrl = process.env.REACT_APP_API_URL_2;
      const areaRequestBody = {
        Action: "getarea",
        Authkey: "AdgT6SnjAkeLqlkE4",
        cityCode: selectedCityCode,
        cityName: selectedCityName,
        password: sessionStorage.getItem("password"),
        restrictedarea: true,
        stateCode: "",
        userName: sessionStorage.getItem("userName"),
      };
      const areaResponse = await fetch(areaApiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(areaRequestBody),
      });
      const areaData = await areaResponse.json();
      if (areaData.Response && Array.isArray(areaData.Response)) {
        // console.log("area :", areaData.Response);
        setAreaList(areaData.Response);
      }
    } catch (error) {
      console.error("Error fetching area data:", error);
    }
  };

  const handleSelectArea = async (selectArea) => {

    setSelectArea(selectArea);
    setSelectSociety([]);

  };



  const fetchSocietyData = async (selectedAreaCode) => {
    try {
      const societyApiUrl = process.env.REACT_APP_API_URL_2;
      const societyRequestBody = {
        Action: "getsociety",
        Authkey: "AdgT6SnjAkeLqlkE4",
        areaCode: selectedAreaCode,
        password: sessionStorage.getItem("password"),
        userName: sessionStorage.getItem("userName"),
      };
      const societyResponse = await fetch(societyApiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(societyRequestBody),
      });
      const societyData = await societyResponse.json();
      // console.log("societyData.Response", societyData.Response);
      if (societyData.Response && Array.isArray(societyData.Response)) {
        setSocietyList(societyData.Response);
      } else {
        toast.warning(societyData.Message, {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        setSocietyList([]);
      }
    } catch (error) {
      console.error("Error fetching area data:", error);
      setSocietyList([]);
    }
  };


  useEffect(() => {
    if (selectArea) {
      const selectedAreaCode = selectArea.value ? selectArea.value : "";
      // console.log("selectedAreaCode",selectedAreaCode);
      fetchSocietyData(selectedAreaCode);
    }
  }, [selectArea]);



  const OpenCameraCustomer = (e) => {
    if (window.innerWidth >= 1024) {
      e.preventDefault();
      e.stopPropagation();
      Swal.fire({
        html: '<div style="font-size: 15px;">Customer live picture is not allowed on desktop.</div>',
      })
      return;
    }
    Swal.fire({
      html: '<div style="font-size: 20px;">Select Option</div>',
      showCancelButton: true,
      confirmButtonText:
        '<span style="font-size: 15px;color:rgb(148,101,170);">Take Photo</span>',
      cancelButtonText:
        '<span style="font-size: 15px;color:rgb(148,101,170);">Cancel</span>',
      confirmButtonColor: "white",
      cancelButtonColor: "white",
      customClass: {
        popup: "custom-popup",
        confirmButton: "custom-confirm-button",
        cancelButton: "custom-cancel-button",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        // openCamera();
        document.getElementById("cameraFileInputCustomer").click();
      }
    });
  };

  const OpenCameraSeller = () => {
    if (!isOtpVerified) { return; }
    Swal.fire({
      html: '<div style="font-size: 20px;">Select Option</div>',
      showCancelButton: true,
      confirmButtonText:
        '<span style="font-size: 15px;color:rgb(148,101,170);">Take Photo</span>',
      cancelButtonText:
        '<span style="font-size: 15px;color:rgb(148,101,170);">Cancel</span>',
      confirmButtonColor: "white",
      cancelButtonColor: "white",
      customClass: {
        popup: "custom-popup",
        confirmButton: "custom-confirm-button",
        cancelButton: "custom-cancel-button",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        // openCamera();
        document.getElementById("cameraFileInputSeller").click();
      }
    });
  };


  const [fileName, setFileName] = useState("");

  const handleFileChangeCustomer = async (event) => {
    const file = event.target.files[0];
    // console.log("handleFileChangeCustomer: ", file.name);
    const extension = (file.name).substring((file.name).lastIndexOf("."));
    let fileName = 'customer_live_picture' + extension;


    if (!file) {
      toast.warning("Please Capture Live Picture", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }

    setLoading(true)
    // Set compression options
    const options = {
      maxSizeMB: 1, // Maximum file size in MB
      maxWidthOrHeight: 1920, // Max width or height
      useWebWorker: true, // Use web worker for faster compression
    };
    try {
      // Compress the image file
      const compressedFile = await imageCompression(file, options);
      // Create a FileReader instance
      const reader = new FileReader();
      reader.onload = async (e) => {
        let base64StringBasic = e.target.result.split(";base64,")[1];
        let base64String = "";

        // ============ Validate Live Picture =============
        if (userName2?.toLowerCase() == "manager1") {
          try {
            setLoading(true)
            const validateImageReq = {
              "oppID": OppId || "",
              "cafID": CafId || "",
              "latitude": Caflatitude || "",
              "longitude": Caflongitude || "",
              "emp_code": sessionStorage.getItem("empId"),
              "image_base64": base64StringBasic
            }
            const imagevalidateResult = await api.validateImage(validateImageReq)
            const imagevalidate = imagevalidateResult?.data?.result;
            // console.log("imagevalidate: ", imagevalidate);

            if (imagevalidate?.code == 200 || imagevalidate?.code == 203) {
              setCustomerImageStatus(imagevalidate)
              if (imagevalidate?.code == 200) {
                base64String = imagevalidate?.data?.watermarked_image
              } else {
                return
              }
            } else {
              setCustomerImageStatus(null)
            }

          } catch (err) {
            console.error(err);
            setCustomerImageStatus(null)
          } finally { setLoading(false) }
        }
        // console.log("base64String: ", base64String);


        // console.log("Compressed file content:", base64String); // Log base64 content
        const inputText = "Picture Captured";
        setCustomerImg(base64String);
        setCustomerPicture({ fileNameWithExtension: fileName, fileContent: base64String });
        setNewCafUpdateRequestBody((prevData) => ({
          ...prevData,
          customerImage: { fileNameWithExtension: fileName, fileContent: base64String }
        }));

        // console.log({ fileNameWithExtension: fileName, fileContent: base64String });


        setFileName(inputText); // Set the input text
        // setBase64Content(base64String); // Set the base64 content
      };
      reader.readAsDataURL(compressedFile);
    } catch (error) {
      console.error("Error compressing the image:", error);
      toast.error("Error compressing the image. Please try again.", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } finally {
      setLoading(false)
    }
  };

  // const now = new Date();
  // const formattedDate = now.toLocaleString("en-GB", {
  //   year: "numeric", month: "2-digit", day: "2-digit",
  //   hour: "2-digit", minute: "2-digit", second: "2-digit",
  //   hour12: false
  // }).replace(/\//g, "-").replace(",", "");


  const now = new Date();
  // Format date as YYYY-MM-DD
  const datePart = now.toISOString().split("T")[0];
  // Format time as HH:MM:SS
  const timePart = now.toTimeString().split(" ")[0];
  const formattedDate = `${datePart} ${timePart}`;



  const handleFileChangeSeller = async (event) => {
    const file = event.target.files[0];
    // console.log("handleFileChange: ", file);
    const extension = (file.name).substring((file.name).lastIndexOf("."));
    let fileName = 'seller_live_picture' + extension;
    let sellerOtp = userdata?.otp;
    // console.log("sellerOtp", sellerOtp);

    if (!file) {
      toast.warning("Please Capture Live Picture", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    // Set compression options
    const options = {
      maxSizeMB: 1, // Maximum file size in MB
      maxWidthOrHeight: 1920, // Max width or height
      useWebWorker: true, // Use web worker for faster compression
    };
    try {
      // Compress the image file
      const compressedFile = await imageCompression(file, options);
      // Create a FileReader instance
      const reader = new FileReader();
      reader.onload = (e) => {
        const base64String = e.target.result.split(";base64,")[1];
        // console.log("Compressed file content:", base64String); // Log base64 content
        const inputText = "Picture Captured";
        setSellerPicture({ sellerFileNameWithExtension: fileName, sellerFileContent: base64String });
        setNewCafUpdateRequestBody((prevData) => ({
          ...prevData,
          sellerImage: {
            sellerFileNameWithExtension: fileName,
            sellerFileContent: base64String,
            sellerOTPAuthDate: formattedDate,
            sellerOTP: sellerOtp ? sellerOtp : ""
          }
        }));
        // console.log({ fileName: fileName, docBase64: base64String });
        // console.log({
        //   fileName: fileName,
        //   docBase64: base64String,
        //   sellerOtp: sellerOtp, // Ensure OTP is logged
        // });

        setFileName(inputText); // Set the input text
        // setBase64Content(base64String); // Set the base64 content
      };
      reader.readAsDataURL(compressedFile);
    } catch (error) {
      console.error("Error compressing the image:", error);
      toast.error("Error compressing the image. Please try again.", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    }
  };


  const handlePaySlipChange = (selected) => {
    const selectedPayin = selected;
    setselectedPaySlipOption(selectedPayin.value);
  };



  const handleBankChange = (selected) => {
    const selectOption = selected;
    setselectBank(selectOption);
  };


  const handleBranchChange = (e) => {
    const selectOption = e.target.value;
    setbranchName(selectOption);
  };

  const handleChequeNo = (e) => {
    const selectOption = e.target.value;
    setchequeDDNo(selectOption);
  };

  const handleChequeDate = (e) => {
    const selectOption = e.target.value;
    setchequeDate(selectOption);
  };

  const handleGroupChange = (selectedOption) => {
    setSelectedGroup(selectedOption);
  };
  const handleSelectRelationship = (selectRelationship) => {
    setSelectRelationship(selectRelationship);
  };

  const handleIndustryChnage = (selected) => {
    setSelectIndustry(selected);
  };

  const handleProductTypeChange = (selected) => {
    setSelectedProductType(selected);
  };


  const handleFirmTypeChange = (selection) => {
    setSelectedFirmType(selection);
  };




  useEffect(() => {
    setSecuritydep(paymentDetails.SecurityDeposit || "");
  }, [paymentDetails.SecurityDeposit]);


  const handleSecurityDepo = (e) => {
    const selection = e.target.value;
    setSecuritydep(selection);
  };



  const handleSecType = (selected) => {
    const selection = selected;
    setSecuritydeptype(selection.value);
  };

  const [otp, setOtp] = useState("");


  useEffect(() => {
    settransactionrefid(paymentDetails.TransactionId || "");
  }, [paymentDetails.TransactionId]);
  const handleTransactionRefID = (e) => {
    const selection = e.target.value;
    settransactionrefid(selection);
  };

  useEffect(() => {
    setapprovalCode(paymentDetails.ApprovalCode || "");
  }, [paymentDetails.ApprovalCode]);
  const handleApprovalCode = (e) => {
    const selection = e.target.value;
    setapprovalCode(selection);
  };


  const handleCreditdetails = (e) => {
    const selection = e.target.value;
    setcreditDetails(selection);
  };

  const handleDebditdetails = (e) => {
    const selection = e.target.value;
    setDebitDetails(selection);
  }

  const handleSocietyChange = (selection) => {
    setSelectSociety(selection);
  };

  const handleFloorChange = (e) => {
    const input = e.target.value;
    setApiFloorCode(input);
  };
  const handlePinChange = (e) => {
    const input = e.target.value;
    if (input.length <= 6) {
      setApiPinCode(input);
    }
  };
  const handleBlockChange = (e) => {
    const input = e.target.value;
    setApiblockCode(input);
  };



  const handleFloor = (e) => {
    const input = e.target.value;
    setFloor(input);
  };

  const handlePaymentStatus = (selection) => {
    setpaymentStatus(selection);
  };

  const handleSelectSociety = (selectSociety) => {
    setSelectSociety(selectSociety);
  };

  const handleSelectFile = (selectDocument) => {
    // console.log(event.target.value);
    setSelectDocumentType(selectDocument.label);
    setSelectDocument(selectDocument)
  }



  const fetchLatLong = async (address) => {
    try {
      // Prepare API payload
      const payload = {
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        Action: "getLatLong",
        address: address
      };

      // Send API request
      const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      // console.log("Latitude and Longitude fetched successfully:", result);


      if (result?.Status === "Success") {
        // console.log("Latitude and Longitude fetched successfully:", result);
        setCaflatitude(result.Response.latitude);
        setCaflongitude(result.Response.longitude);
        // You can handle the successful response here
      } else {
        console.error("Failed to fetch Latitude and Longitude:", result);
        // Handle failure here
      }
    } catch (error) {
      console.error("Error fetching Latitude and Longitude:", error);
      // Handle error here
    }
  };

  const handleResendOtp = () => {
    SendOtpresotp();
  };

  const handleSubmitOtp = async () => {
    if (!OtpValue) {
      toast.warning("Please Enter OTP", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    } else if (OtpValue != OtpValue2) {
      toast.warning("Please Enter Valid OTP", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }

    try {
      setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL_2;

      const requestData = {
        Action: "otpAuthentication",
        Authkey: "AdgT6SnjAkeLqlkE4",
        CAFNumber: CafId,
        OTPCode: OtpValue2,
        password: sessionStorage.getItem("password"),
        userName: sessionStorage.getItem("userName"),
      };

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();

      // console.log("API Response OTPSUBMIT:", result);

      if (result.Response.StatusCode === "OK") {
        toast.success("OTP Authenticated Successfully", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        setotpAuthStatus(true);
      } else {
        toast.warning(result.Response.StatusCode || "OTP not Authenticated", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    } finally {
      // setLoading(false);
    }
  };


  const handleSendOtp = async () => {
    setCodeFlag(true)
    if (!isTimerActive) {
      // console.log("Code Sent!");
      startTimer(30); // Start a 30-second timer
    }
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const otpRequestBody = {
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        Action: "generateOTPforSel",
        userName: sessionStorage.getItem('userName'),
        password: sessionStorage.getItem('password'),
        GenerateOTP: "Yes",
      };

      const otpResponse = await fetch(apiUrl, {
        method: "POST", headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(otpRequestBody),
      });

      const sendOtpData = await otpResponse.json();
      // console.log("send otp :", sendOtpData)
      if (sendOtpData.Status === "Success") {
        // console.log("send otp :", sendOtpData.Status)
        // setOtpSent(true);
        setOtp(sendOtpData.Response.OTP);

        // console.log("sendOtpData.Response :", sendOtpData.Response.OTP);
      } else {
        console.error('Failed to send OTP:', otpResponse.statusText);
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
    }

  };


  const startTimer = (seconds) => {
    setIsTimerActive(true);
    setTimer(seconds);

    const interval = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          setIsTimerActive(false); // Enable the resend button
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };



  const handleFileChangekycDocOCR = async (event) => {
    try {
      const file = event.target.files[0];
      const file1 = event.target.files[0].name;
      // console.log("file1",file1);
      setSelectKycDoc(file1);
      if (!file) {
        toast.warning("Select KYC Document", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }
      setLoading(true);
      // console.log("handleFileChange: ", file);
      const extension = file.name.substring(file.name.lastIndexOf("."));
      const fileType = file.type; // MIME type of the file
      let fileName = getSelectDocumentType + extension;

      // Check if the file is an image
      if (fileType.startsWith("image/")) {
        // Set compression options for images
        const options = {
          maxSizeMB: 1, // Maximum file size in MB
          maxWidthOrHeight: 1920, // Max width or height
          useWebWorker: true, // Use web worker for faster compression
        };

        const compressedFile = await imageCompression(file, options);

        // Read the compressed file as Base64
        const reader = new FileReader();
        reader.onload = async (e) => {
          const base64String = e.target.result.split(";base64,")[1];
          await processKYCFile(fileName, base64String);
        };
        reader.readAsDataURL(compressedFile);
      } else if (fileType === "application/pdf") {
        // Read the PDF file as Base64
        const reader = new FileReader();
        reader.onload = async (e) => {
          const base64String = e.target.result.split(";base64,")[1];
          await processKYCFile(fileName, base64String);
        };
        reader.readAsDataURL(file);
      } else {
        toast.warning("Unsupported file type. Please upload an image or PDF", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }
    } catch (error) {
      console.error("Error processing file:", error);
      // toast.error("Error uploading document.");
    } finally {
      // setLoading(false);
      setLoading(false);
    }
  };


  const processKYCFile = async (fileName, base64String) => {
    try {
      setLoading(true);
      let docType = selectDocument.value;
      const payload = {
        Action: "kycDocOCR",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        type: selectDocument.value, // Adjust type based on context
        userName: sessionStorage.getItem("userName"),
        password: sessionStorage.getItem("password"),
        filename: fileName,
        filecontent: base64String,
        back: "both",
      };

      // console.log(payload);


      const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      let addressValue = null;

      if (Array.isArray(result?.Response?.data)) {
        addressValue = result.Response.data.find(
          (item) => item.document_type === "aadhaar_front_top" && item.address
        )?.address?.value;
      } else {
        console.error("Error: result.Response.data is not an array", result?.Response?.data);
      }

      if (docType == "MCA") {
        await getMcaVerification(result)
        return;
      }

      if (result?.Status === "Success") {
        // console.log("KYC document processed successfully:", result);
        const documentData = result.Response?.data[0];
        const possibleKeys = {
          cin: "cin",
          gstin: "gstin",
          pan: "pan_number",
          aadhar: "aadhar",
          voterId: "voterId",
          DL: "DL",
        };

        let documentValue = null;
        for (const [key, actualKey] of Object.entries(possibleKeys)) {
          if (documentData?.[actualKey]?.value) {
            documentValue = documentData[actualKey].value;
            break;
          }
        }

        // console.log("documentValue:", documentValue);



        if (["aadhaar_front_bottom", "aadhaar_front_top"].includes(documentData?.document_type)) {

          const adharName = documentData.full_name.value;
          // const adharName = "Nitin Chhabbra";
          // console.log("adharName", adharName);

          //  const fullName = firstName +" "+ lastName;
          const fullName = leadName;
          //  const fullName = "Nitin Chhabbra";
          // console.log("fullName", fullName);
          const normalizedFullName = fullName.replace(/\s+/g, "").toLowerCase();
          const normalizedadharName = adharName.replace(/\s+/g, "").toLowerCase();
          if (normalizedFullName == normalizedadharName) {
            setKycDocStatus(result.Status);
            toast.success("Document details validated successfully", {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            });
          } else {
            toast.warning("Customer name on KYC document is not matching, please upload valid document", {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            });
          }

          handleGetCompanyGroupDigi(adharName);
          setNewCafUpdateRequestBody((prevData) => ({
            ...prevData,
            customerKYCdocument: {
              customerKYCAddress: addressValue || "",
              customerKYCfileNameWithExtension: fileName,
              customerKYCfileContent: base64String,
            },
          }));
        } else if (documentData?.document_type === "pan") {

          const panName = documentData.full_name.value;
          // const panName = "Seoperation Marketing Private Limited";
          // const fullName = firstName +" "+ lastName;
          const fullName = leadName;
          // const fullName = "Seoperation Marketing Private Limited";
          // console.log("fullName", fullName);
          const normalizedFullName = fullName.replace(/\s+/g, "").toLowerCase();
          const normalizedPanName = panName.replace(/\s+/g, "").toLowerCase();
          if (normalizedFullName == normalizedPanName) {
            setKycDocStatus(result.Status);
            toast.success("Document details validated successfully", {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            });
          } else {
            toast.warning("Customer name on KYC document is not matching, please upload valid document", {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            });
          }

          handleGetCompanyGroupDigi(panName);
          setNewCafUpdateRequestBody((prevData) => ({
            ...prevData,
            customerKYCdocument: {
              customerKYCAddress: "",
              customerKYCfileNameWithExtension: fileName,
              customerKYCfileContent: base64String,
            },
          }));
        }
        else if (result.Response.data.client_id) {
          const lienceIdNum = result.Response.data.license_number.value;
          const liecenceDOB = result.Response.data.dob.value;
          // const cName = name;
          // setKycDocStatus(result.Status);

          await handleGetCustomerDocDetailDigi(result, documentValue, liecenceDOB, lienceIdNum);
          setNewCafUpdateRequestBody((prevData) => ({
            ...prevData,
            customerKYCdocument: {
              customerKYCAddress: "",
              customerKYCfileNameWithExtension: fileName,
              customerKYCfileContent: base64String,
            },
          }));
        }
        else {
          const customerDocDetail = await handleGetCustomerDocDetailDigi(result, documentValue);
          setNewCafUpdateRequestBody((prevData) => ({
            ...prevData,
            customerKYCdocument: {
              customerKYCAddress:
                customerDocDetail?.Response?.data?.details?.company_info?.registered_address || "",
              customerKYCfileNameWithExtension: fileName,
              customerKYCfileContent: base64String,
            },
          }));
        }
      } else {
        console.error("Failed to process KYC document:", result);
        toast.warning("Please select a valid document", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
      }
    } catch (error) {
      console.error("Error in KYC processing API:", error);
      toast.warning("Error processing the document", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } finally {
      setLoading(false);
    }
  };



  const handleGetCustomerDocDetailDigi = async (data, docNumber, liecenceDOB, lienceIdNum) => {
    // console.log("setDocnumber", docNumber)
    try {
      let docType = selectDocument.value;
      if (docType === 'CIN') {
        docType = "COI"
      }

      const apiUrl = process.env.REACT_APP_API_URL
      const payload = {
        Action: "getCustomerDocDetailDigi",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        userName: sessionStorage.getItem('userName'),
        password: sessionStorage.getItem('password'),
        type: docType,
        refid: data.Response?.reference_id,
        id_number: docNumber || lienceIdNum,
        filing_status: "true",
        dob: liecenceDOB ? liecenceDOB : null,
        client_id: ""
      };
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      if (result?.Status === "Success") {

        // console.log("getCustomerDocDetailDigi", result);

        // const coiCompany = result.Response?.data?.company_name;
        const liecenCompany = result?.Response?.data.license_number;
        // console.log("coiCompany", coiCompany);
        // console.log("liecenCompany", liecenCompany);


        if (liecenCompany) {
          const liecenName = result?.Response?.data.name;
          // const liecenName = "MADHUSUDHAN  R"
          // const fullName = "MADHUSUDHAn  R"
          // const fullName = firstName +" "+ lastName;
          const fullName = leadName;
          // console.log("fullName", fullName);
          const normalizedFullName = fullName.replace(/\s+/g, "").toLowerCase();
          const normalizedliecenCompany = liecenName.replace(/\s+/g, "").toLowerCase();
          if (normalizedFullName == normalizedliecenCompany) {
            setKycDocStatus(result.Status);
            toast.success("Document details validated successfully", {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            });
          } else {
            toast.warning("Customer name on KYC document is not matching, please upload valid document", {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            });
          }

          handleGetCompanyGroupDigi(liecenName);
        }
        else {
          if (docType == "GST") {
            // console.log("busiName", result?.Response?.data.business_name)
            const busiName = result?.Response?.data.business_name;
            const legalName = result?.Response?.data.legal_name;
            // console.log("busiName", busiName);
            // const fullName = firstName +" "+ lastName;
            const fullName = leadName;
            // const fullName = "DEV IT SERV PRIVATE LIMITED";
            // console.log("fullName", fullName);
            const normalizedFullName = fullName.replace(/\s+/g, "").toLowerCase();
            const normalizedbusiName = busiName.replace(/\s+/g, "").toLowerCase();
            const normalizedLegalName = legalName.replace(/\s+/g, "").toLowerCase();
            if ((normalizedFullName == normalizedbusiName) || (normalizedFullName == normalizedLegalName)) {
              setKycDocStatus(result.Status);
              toast.success("Document details validated successfully", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
              });
            } else {
              toast.warning("Customer name on KYC document is not matching, please upload valid document", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
              });
            }

            handleGetCompanyGroupDigi(busiName);
          }
          const coiCompany = result.Response?.data?.company_name;
          // const coiCompany = "SHYAM SPECTRA PRIVATE LIMITED";
          // console.log("coiCompany", coiCompany);
          //  const fullName = firstName +" "+ lastName;
          const fullName = leadName;
          //  const fullName = "DEV IT SERV PRIVATE LIMITED"
          // console.log("fullName", fullName);
          const normalizedFullName = fullName.replace(/\s+/g, "").toLowerCase();
          const normalizedCoiCompany = coiCompany.replace(/\s+/g, "").toLowerCase();
          if (normalizedFullName == normalizedCoiCompany) {
            setKycDocStatus(result.Status);
            toast.success("Document details validated successfully", {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            });
          } else {
            toast.warning("Customer name on KYC document is not matching, please upload valid document", {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 2000,
            });
          }

          const companyName = result.Response?.data?.company_name;
          handleGetCompanyGroupDigi(companyName);

        }


        // toast.success("Document details validated successfully", {
        //   position: toast.POSITION.BOTTOM_CENTER,
        //   autoClose: 1500,
        // });
        // console.log("result?.Response?.data.company_name", result?.Response?.data.company_name);
        // if (result.Response.data.license_number) {
        //   const companyName = result?.Response?.data.name;
        //   handleGetCompanyGroupDigi(companyName);
        // } else {
        //   if (docType == "GST") {
        //     console.log("gstDoctype", result?.Response?.data.business_name)
        //     const companyName = result?.Response?.data.business_name;
        //     handleGetCompanyGroupDigi(companyName);
        //   }
        //   else {
        //     // console.log("companyName",companyName)
        //     const companyName = result.Response?.data?.company_name;
        //     handleGetCompanyGroupDigi(companyName);

        //   }
        // }
      } else {
        console.error("Failed to retrieve customer document details:", result);
        toast.warning("please Select valid document", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
      }
    } catch (error) {
      console.error("Error retrieving customer document details:", error);
      // toast.warning("Error retrieving document details", {
      //   position: toast.POSITION.BOTTOM_CENTER,
      //   autoClose: 1500,
      // });

    }
  };

  const getMcaVerification = async (result) => {
    // console.log("setDocnumber", docNumber)
    try {
      // let docType = selectDocument.value;

      if (result?.Status === "Success") {
        // console.log("getCustomerDocDetailDigi", result);

        // const coiCompany = result.Response?.data?.company_name;
        const liecenCompany = result?.Response?.data.license_number;
        // console.log("coiCompany", coiCompany);
        // console.log("liecenCompany", liecenCompany);

        const coiCompany = result.Response?.data?.company_name;
        // const coiCompany = "SHYAM SPECTRA PRIVATE LIMITED";
        // console.log("coiCompany", coiCompany);
        //  const fullName = firstName +" "+ lastName;
        const fullName = firstName;
        //  const fullName = "DEV IT SERV PRIVATE LIMITED"
        // console.log("fullName", fullName);
        const normalizedFullName = fullName.replace(/\s+/g, "").toLowerCase();
        const normalizedCoiCompany = coiCompany.replace(/\s+/g, "").toLowerCase();
        if (normalizedFullName == normalizedCoiCompany) {
          setKycDocStatus(result.Status);
          toast.success("Document details validated successfully", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        } else {
          toast.warning("Customer name on KYC document is not matching, please upload valid document", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 2000,
          });
        }

        const companyName = result.Response?.data?.company_name;
        handleGetCompanyGroupDigi(companyName);

      } else {
        console.error("Failed to retrieve customer document details:", result);
        toast.warning("please Select valid document", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
      }
    } catch (error) {
      console.error("Error retrieving customer document details:", error);
      // toast.warning("Error retrieving document details", {
      //   position: toast.POSITION.BOTTOM_CENTER,
      //   autoClose: 1500,
      // });

    }
  };

  const handleGetCompanyGroupDigi = async (customerName) => {
    try {
      // Prepare API payload
      const apiurl = process.env.REACT_APP_API_URL
      const payload = {
        Action: "getCompanyGroupDigi",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        customerName: customerName,
        password: sessionStorage.getItem('password'),
        userName: sessionStorage.getItem('userName')
      };

      // Send API request
      const response = await fetch(apiurl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (result?.Status === "Success") {
        // toast.success(result?.Response.Message, {
        //   position: toast.POSITION.BOTTOM_CENTER,
        //   autoClose: 1500,
        // });
      } else {
        // toast.warning(result?.Response.Message, {
        //   position: toast.POSITION.BOTTOM_CENTER,
        //   autoClose: 1500,
        // });
      }
    } catch (error) {
      console.error("Error retrieving company group data:", error);
      // toast.success("Error retrieving data", {
      //   position: toast.POSITION.BOTTOM_CENTER,
      //   autoClose: 1500,
      // });
    }
  };


  const handleVerifyOtp = () => {
    // const otpValue = String(otp).trim();
    // const customerOtpValue = userdata.otp.trim();

    // console.log("userData.otp :", userdata.otp);
    // console.log("otp :", otp);
    if (otp === userdata.otp) {
      setOtpVerified(true)
      toast.success("OTP verified Successfully", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      // setOtpContactStatus("111260000");
    } else {
      setOtpVerified(false)
      toast.error("Incorrect OTP", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      // setOtpContactStatus("111260001");
    }
  };




  const SendOtpresotp = async () => {
    try {
      setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL_2;

      const requestData = {
        Action: "resendOTP",
        Authkey: "AdgT6SnjAkeLqlkE4",
        CAFNumber: CafId,
        password: sessionStorage.getItem("password"),
        userName: sessionStorage.getItem("userName"),
      };

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();

      // console.log("API Response OTP:", result);

      if (result.Response.OTPStatus === "OTP Sent") {
        toast.success("OTP Sent Succesfully", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        setOtpValue2(result.Response.OTPCode);
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    } finally {
      setLoading(false);
    }
  };









  const handleSave = async () => {
    const regexPAN = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    const regexTAN = /^[A-Z]{4}[0-9]{5}[A-Z]{1}$/;
    const regexGST = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9A-Z]{3}$/;

    if (userdata.gstNo) {
      if (!regexGST.test(userdata.gstNo)) {
        toast.error(
          "Please enter GST in CAPITAL Letters and correct format (e.g., 12ABCDE1234A1A1 or 12ABCDE1234A1AA)",
          { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 }
        );
        return;
      }

      // Mapping from State Name to its corresponding GST Code (as per GST value table).
      const stateGSTMapping = {
        "Jammu & Kashmir": "01",
        "Himachal Pradesh": "02",
        "Punjab": "03",
        "Chandigarh": "04",
        "Uttarakhand": "05",
        "Haryana": "06",
        "Delhi": "07",
        "Rajasthan": "08",
        "Uttar Pradesh": "09",
        "Bihar": "10",
        "Sikkim": "11",
        "Arunachal Pradesh": "12",
        "Nagaland": "13",
        "Manipur": "14",
        "Mizoram": "15",
        "Tripura": "16",
        "Meghalaya": "17",
        "Assam": "18",
        "West Bengal": "19",
        "Jharkhand": "20",
        "Odisha": "21",
        "Chhattisgarh": "22",
        "Madhya Pradesh": "23",
        "Gujarat": "24",
        "Daman & Diu": "25",
        "Dadra & Nagar Haveli": "26",
        "Maharashtra": "27",
        "Andhra Pradesh": "28",  // Andhra Pradesh may also use '37' in certain cases.
        "Karnataka": "29",
        "Goa": "30",
        "Lakshadweep": "31",
        "Kerala": "32",
        "Tamil Nadu": "33",
        "Puducherry": "34",
        "Andaman & Nicobar Islands": "35",
        "Telangana": "36",
        "Ladakh": "38",
        "Others Territory": "97",
        "Center Jurisdiction": "99"
      };

      // If a state is selected via selectInstState, verify that the GST number starts with the state's GST code.
      // Assume selectInstState is an object with at least a 'name' property.
      if (selectState && selectState?.label && stateGSTMapping[selectState?.label]) {
        const expectedGSTPrefix = stateGSTMapping[selectState?.label];
        const gstPrefix = userdata?.gstNo.slice(0, 2); // Extract first two digits from the GST.
        if (gstPrefix !== expectedGSTPrefix) {
          toast.error(
            `GST number does not match the selected state's GST code. Expected prefix: ${expectedGSTPrefix}`,
            { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 }
          );
          return;
        }
      }
    }

    // PAN Validation: if field is not empty, then validate format.
    if (userdata.panNo && !regexPAN.test(userdata.panNo)) {
      toast.error(
        "Please enter PAN in CAPITAL Letters and correct format (ABCDE1234A)",
        { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 }
      );
      return;
    }

    // TAN Validation: if field is not empty, then validate format.
    if (userdata.tanNo && !regexTAN.test(userdata.tanNo)) {
      toast.error(
        "Please enter TAN in CAPITAL Letters and correct format (ABCD12345A)",
        { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 }
      );
      return;
    }

    if (!salutate) {
      toast.warning("Please Select Salutation", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!gender) {
      toast.warning("Please Select Gender", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!firstName) {
      toast.warning("Please Enter First Name", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    }
    else if (!mobileNo) {
      toast.warning("Please Enter Mobile Number", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!emailId) {
      toast.warning("Please Enter Email", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!userdata?.ProfessionofSubscriber) {
      toast.warning("Please Enter Profession of Subscriber", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!userdata?.DOBorDateofRegistration) {
      toast.warning("Please Enter DOB/Date of registration", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!billingEmailId) {
      toast.warning("Please Enter Billing Email ID", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!techSupportEmail) {
      toast.warning("Please Enter Technical Support Email ID", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    }
    else if (!selectState.value) {
      toast.warning("Please Select State", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!selectCity?.value) {
      toast.warning("Please Select City", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!selectArea?.value) {
      toast.warning("Please Select Area", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!apipinCode) {
      toast.warning("Please Enter Pincode", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!selectedProductType) {
      toast.warning("Please Select Product", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!selectRelationship) {
      toast.warning("Please Select Relationship", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!selectCity?.value) {
      toast.warning("Please Select City", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!selectArea?.value) {
      toast.warning("Please Select Area", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!selectSociety?.value) {
      toast.warning("Please Select Society", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!userdata.authName) {
      toast.warning("Please Enter Auther Name", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!userdata.authFatherName) {
      toast.warning("Please Enter Auther Father Name", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!userdata.authResidentialAdd) {
      toast.warning("Please Enter Residential Address", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!userdata.authMobile) {
      toast.warning("Please Enter Auther Number", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!userdata.authEmail) {
      toast.warning("Please Enter Auther Email", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!userdata.authPinCode) {
      toast.warning("Please Enter Auther PinCode", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!selectAuthState.value) {
      toast.warning("Please Select Auther State", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!selectAuthCity.value) {
      toast.warning("Please Select Auther City", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!selectedFirmType.value) {
      toast.warning("Please Select Firm Type", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!getSellerPicture?.sellerFileNameWithExtension) {
      toast.warning("Seller Live Picture is Required", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    }
    else {
      try {
        setLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL_2;
        const postData = {
          Action: "createcafDZationHome",
          Authkey: "AdgT6SnjAkeLqlkE4",
          AccountDetail: {
            CompanyId: selectedCompany ? selectedCompany?.value : "",
            GroupId: selectedGroup ? selectedGroup?.value : "",
            RelationshipId: selectRelationship ? selectRelationship?.value : "",
            area: selectArea.value ? selectArea.value : "",
            blockTower: apiblockCode ? apiblockCode : "",
            businessSegment: "Home",
            city: selectCity.value ? selectCity.value : "",
            country: "10001",
            emailId: emailId ? emailId : "",
            firstName: firstName ? firstName : "",
            housePlotFlatNumber: apiFloorCode ? apiFloorCode : "",
            lastName: lastName ? lastName : "",
            mobileNo: mobileNo ? mobileNo : "",
            phoneNo: mobileNo ? mobileNo : "",
            postalCode: apipinCode ? apipinCode : "",
            product: selectedProductType ? selectedProductType.value : "",
            salutationId: salutate ? salutate : "",
            society: selectSociety.value ? selectSociety.value : "",
            state: selectState ? selectState.value : "",
            subBusinessSegment: "FTTH",
          },
          AuthorSigDetails: {
            authEmailID: userdata.authEmail ? userdata.authEmail : "",
            authFatherORhusbandName: userdata.authFatherName ? userdata.authFatherName : "",
            authLandmark: "0",
            authMobileNumber: userdata.authMobile ? userdata.authMobile : "",
            authName: userdata.authName ? userdata.authName : "",
            authResidentialAddress: userdata.authResidentialAdd ? userdata.authResidentialAdd : "",
            authcity: selectAuthCity ? selectAuthCity.value : "",
            authcountry: selectAuthCountry ? selectAuthCountry.value : "",
            authpostalCode: userdata.authPinCode ? userdata.authPinCode : "",
            authstate: selectAuthState ? selectAuthState.value : ""
          },
          PaymentDetail: {
            amount: userdata.totalAmount ? userdata.totalAmount : "",
            approvalCode: approvalCode ? approvalCode : "",
            otc: userdata.UpfrontReqOTCAmount ? userdata.UpfrontReqOTCAmount : "",
            branchName: branchName ? branchName : "",
            chequeDDNo: chequeDDNo ? chequeDDNo : "",
            creditCardDigits: creditDetails ? creditDetails : "",
            debitCardDigits: debitDetails ? debitDetails : "",
            payInSlip: selectedPaySlipOption ? selectedPaySlipOption : "",
            paymentDate: selectedDate ? selectedDate : "",
            paymentStatus: paymentStatus.value ? paymentStatus.value : "",
            securityDeposit: userdata.UpfrontReqSDAmount ? userdata.UpfrontReqSDAmount : "",
            securityDepositType: Securitydeptype ? Securitydeptype : "",
            transactionId: transactionrefid ? transactionrefid : "",
            rc: userdata.UpfrontReqRCAmount ? userdata.UpfrontReqRCAmount : ""
          },

          cafdetail: {
            TechnicalSupportEmailID: techSupportEmail || "",
            BillingEmailID: billingEmailId || "",
            CompanyId: selectedCompany ? selectedCompany?.value : "",
            GroupId: selectedGroup ? selectedGroup?.value : "",
            PANNo: userdata?.panNo || "",
            RelationshipId: selectRelationship ? selectRelationship?.value : "",
            TANNo: userdata?.tanNo || "",
            area: selectArea.value ? selectArea.value : "",
            businessSegment: "Home",
            cafNo: CafId ? CafId : "",
            city: selectCity.value ? selectCity.value : "",
            country: "10001",
            customerName: firstName ? firstName : "",
            emailId: emailId ? emailId : "",
            gSTNo: userdata?.gstNo || "",
            housePlotFlatNumber: apiFloorCode ? apiFloorCode : "",
            isGST: "",
            mobileNo: mobileNo ? mobileNo : "",
            phoneNo: "",
            postalCode: apipinCode ? apipinCode : "",
            // product: "Prod_002622_ID",
            product: selectedProductType ? selectedProductType.value : "",
            society: selectSociety.value ? selectSociety.value : "",
            state: selectState ? selectState.value : "",
            subBusinessSegment: "FTTH",
            voice: "0",
            opportunityID: OppId ? OppId : "",
            latitude: Caflatitude ? Caflatitude : "",
            longitude: Caflongitude ? Caflongitude : "",
            industryType: selectIndustry?.label ? selectIndustry?.label : "",
            Floor: floor ? floor : "",

            ProfessionofSubscriber: userdata?.ProfessionofSubscriber || "",
            Gender: gender || "",
            DOBorDateofRegistration: userdata?.DOBorDateofRegistration || ""
          },
          customerImage: checkboxes.check19 ? checkboxes.check19 : "",
          documentRequired: {
            AadharNo: "",
            CompanyId: selectedCompany ? selectedCompany.value : "",
            FirmType: selectedFirmType.value ? selectedFirmType.value : "",
            GroupId: selectedGroup ? selectedGroup.value : "",
            PassportNo: "",
            RelationshipId: selectRelationship ? selectRelationship.value : "",
            VoterNo: "",
            aadharCard: checkboxes.AadharCard,
            aadharCardPhotoId: checkboxes.AadharCardPhotoId,
            bankPassbook: checkboxes.BankPassbook,
            centralStateGovtId: checkboxes.CentralStateGovtId,
            centralStateGovtIdPhotoId: checkboxes.CentralStateGovtIdPhotoId,
            creditCardStatement: checkboxes.CreditCardStatement,
            documentData: null,
            drivingLicense: checkboxes.DrivingLicense,
            drivingLicenseNo: "",
            drivingLicensePhotoId: checkboxes.DrivingLicensePhotoId,
            electricityBill: checkboxes.ElectricityBill,
            electricityIssueDate: "",
            gasConnection: checkboxes.GasConnection,
            gasConnectionIssueDate: "",
            panCardPhotoId: checkboxes.PanCardPhotoId,
            passport: checkboxes.Passport,
            passportPhotoId: checkboxes.PassportPhotoId,
            rationCardPhotoId: checkboxes.RationCardPhotoId,
            rentAgreement: checkboxes.RentAgreement,
            telephoneBill: checkboxes.TelephoneBill,
            telephoneIssueDate: "",
            votercard: checkboxes.Votercard,
            votercardPhotoId: checkboxes.VotercardPhotoId,
            waterBill: checkboxes.WaterBill,
            waterBillIssueDate: "",
          },
          // customerImage: getNewCafUpdateRequestBody.customerImage,
          customerImage: {
            fileNameWithExtension: getCustomerPicture?.fileNameWithExtension || getNewCafUpdateRequestBody?.customerImage?.fileNameWithExtension,
            fileContent: customerImg || getNewCafUpdateRequestBody?.customerImage?.fileContent
          },
          sellerImage: getNewCafUpdateRequestBody.sellerImage,
          customerKYCdocument: getNewCafUpdateRequestBody.customerKYCdocument,
          lampCafId: "",
          lampLeadId: leadId ? leadId : "",
          password: sessionStorage.getItem("password"),
          userName: sessionStorage.getItem("userName"),
        };

        const requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(postData),
        };
        // console.log("API Response:", postData);

        const response = await fetch(apiUrl, requestOptions);

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();

        // console.log("API Response:", data);
        if (data.Response.StatusName === "CAF created") {
          toast.success("CAF Created Successfully", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });

          navigate("/broadbandCaf");
          return;
        } else {
          toast.warning(data.Response.StatusName, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });

        }
      } catch (error) {
        console.error("Error sending data:", error.message);
      } finally {
        setLoading(false);
      }
    }
  };



  const handleUpdate = async () => {

    const regexPAN = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    const regexTAN = /^[A-Z]{4}[0-9]{5}[A-Z]{1}$/;
    const regexGST = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9A-Z]{3}$/;

    if (userdata.gstNo) {
      if (!regexGST.test(userdata.gstNo)) {
        toast.error(
          "Please enter GST in CAPITAL Letters and correct format (e.g., 12ABCDE1234A1A1 or 12ABCDE1234A1AA)",
          { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 }
        );
        return;
      }

      // Mapping from State Name to its corresponding GST Code (as per GST value table).
      const stateGSTMapping = {
        "Jammu & Kashmir": "01",
        "Himachal Pradesh": "02",
        "Punjab": "03",
        "Chandigarh": "04",
        "Uttarakhand": "05",
        "Haryana": "06",
        "Delhi": "07",
        "Rajasthan": "08",
        "Uttar Pradesh": "09",
        "Bihar": "10",
        "Sikkim": "11",
        "Arunachal Pradesh": "12",
        "Nagaland": "13",
        "Manipur": "14",
        "Mizoram": "15",
        "Tripura": "16",
        "Meghalaya": "17",
        "Assam": "18",
        "West Bengal": "19",
        "Jharkhand": "20",
        "Odisha": "21",
        "Chhattisgarh": "22",
        "Madhya Pradesh": "23",
        "Gujarat": "24",
        "Daman & Diu": "25",
        "Dadra & Nagar Haveli": "26",
        "Maharashtra": "27",
        "Andhra Pradesh": "28",  // Andhra Pradesh may also use '37' in certain cases.
        "Karnataka": "29",
        "Goa": "30",
        "Lakshadweep": "31",
        "Kerala": "32",
        "Tamil Nadu": "33",
        "Puducherry": "34",
        "Andaman & Nicobar Islands": "35",
        "Telangana": "36",
        "Ladakh": "38",
        "Others Territory": "97",
        "Center Jurisdiction": "99"
      };

      // If a state is selected via selectInstState, verify that the GST number starts with the state's GST code.
      // Assume selectInstState is an object with at least a 'name' property.
      if (selectState && selectState.label && stateGSTMapping[selectState.label]) {
        const expectedGSTPrefix = stateGSTMapping[selectState.label];
        const gstPrefix = userdata.gstNo.slice(0, 2); // Extract first two digits from the GST.
        if (gstPrefix !== expectedGSTPrefix) {
          toast.error(
            `GST number does not match the selected state's GST code. Expected prefix: ${expectedGSTPrefix}`,
            { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 }
          );
          return;
        }
      }
    }

    // PAN Validation: if field is not empty, then validate format.
    if (userdata.panNo && !regexPAN.test(userdata.panNo)) {
      toast.error(
        "Please enter PAN in CAPITAL Letters and correct format (ABCDE1234A)",
        { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 }
      );
      return;
    }

    // TAN Validation: if field is not empty, then validate format.
    if (userdata.tanNo && !regexTAN.test(userdata.tanNo)) {
      toast.error(
        "Please enter TAN in CAPITAL Letters and correct format (ABCD12345A)",
        { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 }
      );
      return;
    }

    if (selectedPaySlipOption == "5" || selectedPaySlipOption == "13" || selectedPaySlipOption == "4") {
      if (!transactionrefid) {
        toast.warning("Please Enter Transaction Reference Id", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }
      if (!selectedDate) {
        toast.warning("Please Select Payment Date", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }
    }
    if (selectedPaySlipOption === "1" || selectedPaySlipOption === "2") {
      if (!selectBank.value) {
        toast.warning("Please Select Bank", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }
      if (!branchName) {
        toast.warning("Please Enter Branch Name", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }
      if (!chequeDDNo) {
        toast.warning("Please Enter Cheque/DD No.", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }
      if (!chequeDate) {
        toast.warning("Please Select Cheque/DD Date", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }
    }
    if (!salutate) {
      toast.warning("Please Select Salutation", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!gender) {
      toast.warning("Please Select Gender", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!firstName) {
      toast.warning("Please Enter First Name", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    }
    else if (!mobileNo) {
      toast.warning("Please Enter Mobile Number", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!emailId) {
      toast.warning("Please Enter Email", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!userdata?.ProfessionofSubscriber) {
      toast.warning("Please Enter Profession of Subscriber", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!userdata?.DOBorDateofRegistration) {
      toast.warning("Please Enter DOB/Date of registration", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!billingEmailId) {
      toast.warning("Please Enter Billing Email ID", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!techSupportEmail) {
      toast.warning("Please Enter Technical Support Email ID", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    }
    else if (!selectState.value) {
      toast.warning("Please Select State", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!selectCity?.value) {
      toast.warning("Please Select City", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!selectArea?.value) {
      toast.warning("Please Select Area", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!apipinCode) {
      toast.warning("Please Enter Pincode", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!selectedProductType) {
      toast.warning("Please Select Product", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!selectRelationship) {
      toast.warning("Please Select Relationship", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!selectCity?.value) {
      toast.warning("Please Select City", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!selectArea?.value) {
      toast.warning("Please Select Area", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!selectSociety?.value) {
      toast.warning("Please Select Society", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    }
    else if (!floor) {
      toast.warning("Please Enter floor", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    }
    else if (!userdata.authName) {
      toast.warning("Please Enter Auther Name", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!userdata.authFatherName) {
      toast.warning("Please Enter Auther Father Name", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!userdata.authResidentialAdd) {
      toast.warning("Please Enter Residential Address", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!userdata.authMobile) {
      toast.warning("Please Enter Auther Number", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!userdata.authEmail) {
      toast.warning("Please Enter Auther Email", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!userdata.authPinCode) {
      toast.warning("Please Enter Auther PinCode", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!selectAuthState.value) {
      toast.warning("Please Select Auther State", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!selectAuthCity.value) {
      toast.warning("Please Select Auther City", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    }
    else if (!selectedFirmType.value) {
      toast.warning("Please Select Firm Type", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    }
    else {
      try {
        setLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL_2;
        const postData = {
          "Authkey": "AdgT6SnjAkeLqlkE4",
          "Action": "updatecafDZationHome",
          "cafdetail": {
            "TechnicalSupportEmailID": techSupportEmail || "",
            "BillingEmailID": billingEmailId || "",
            "cafNo": CafId ? CafId : "",
            "customerName": firstName ? firstName : "",
            "mobileNo": mobileNo ? mobileNo : "",
            "phoneNo": "",
            "emailId": emailId ? emailId : "",
            "country": "10001",
            "state": selectState ? selectState.value : "",
            "city": selectCity?.value ? selectCity?.value : "",
            "area": selectArea?.value ? selectArea?.value : "",
            "society": selectSociety?.value ? selectSociety?.value : "",
            "postalCode": apipinCode ? apipinCode : "",
            "housePlotFlatNumber": apiFloorCode ? apiFloorCode : "",
            "businessSegment": "Home",
            "subBusinessSegment": "FTTH",
            // "product": "Prod_002622_ID",
            "product": selectedProductType ? selectedProductType?.value : "",
            "isGST": "",
            "gSTNo": userdata?.gstNo || "",
            "TANNo": userdata?.tanNo || "",
            "PANNo": userdata?.panNo || "",
            "CompanyId": selectedCompany ? selectedCompany.value : "",
            "GroupId": selectedGroup ? selectedGroup.value : "",
            "RelationshipId": selectRelationship ? selectRelationship.value : "",
            "voice": Voice ? Voice : "",
            "opportunityID": "",
            "Floor": floor ? floor : "",

            "ProfessionofSubscriber": userdata?.ProfessionofSubscriber || "",
            "Gender": gender || "",
            "DOBorDateofRegistration": userdata?.DOBorDateofRegistration || ""
          },
          "AccountDetail": {
            "firstName": firstName ? firstName : "",
            "salutationId": salutate ? salutate : "",
            "lastName": lastName ? lastName : "",
            "mobileNo": mobileNo ? mobileNo : "",
            "phoneNo": mobileNo ? mobileNo : "",
            "emailId": emailId ? emailId : "",
            "country": "10001",
            "state": selectState ? selectState.value : "",
            "city": selectCity?.value ? selectCity?.value : "",
            "area": selectArea?.value ? selectArea?.value : "",
            "society": selectSociety?.value ? selectSociety?.value : "",
            "postalCode": apipinCode ? apipinCode : "",
            "housePlotFlatNumber": apiFloorCode ? apiFloorCode : "",
            "blockTower": apiblockCode ? apiblockCode : "",
            "product": selectedProductType ? selectedProductType?.value : "",
            "businessSegment": "Home",
            "subBusinessSegment": "FTTH",
            "CompanyId": selectedCompany ? selectedCompany?.value : "",
            "GroupId": selectedGroup ? selectedGroup?.value : "",
            "RelationshipId": selectRelationship ? selectRelationship?.value : ""
          },
          "AuthorSigDetails": {
            "authEmailID": userdata.authEmail ? userdata.authEmail : "",
            "authFatherORhusbandName": userdata.authFatherName ? userdata.authFatherName : "",
            "authLandmark": "0",
            "authMobileNumber": userdata.authMobile ? userdata.authMobile : "",
            "authName": userdata.authName ? userdata.authName : "",
            "authResidentialAddress": userdata.authResidentialAdd ? userdata.authResidentialAdd : "",
            "authcity": selectAuthCity ? selectAuthCity?.value : "",
            "authcountry": selectAuthCountry ? selectAuthCountry?.value : "",
            "authpostalCode": userdata.authPinCode ? userdata.authPinCode : "",
            "authstate": selectAuthState ? selectAuthState?.value : ""
          },
          "PaymentDetail": {
            "amount": userdata?.totalAmount ? userdata?.totalAmount : '',
            "approvalCode": approvalCode ? approvalCode : "",
            "bankName": selectBank?.value ? selectBank?.value : "",
            "branchName": branchName ? branchName : "",
            "debitCardDigits": debitDetails ? debitDetails : "",
            "creditCardDigits": creditDetails ? creditDetails : "",
            "transactionId": transactionrefid ? transactionrefid : "",
            "payInSlip": selectedPaySlipOption ? selectedPaySlipOption : "",
            "chequeDDNo": chequeDDNo ? chequeDDNo : "",
            "chequeDDDate": chequeDate ? chequeDate : "",
            "otc": userdata?.UpfrontReqOTCAmount ? userdata?.UpfrontReqOTCAmount : "",
            "paymentStatus": paymentStatus?.value ? paymentStatus?.value : "",
            "securityDeposit": userdata?.UpfrontReqSDAmount ? userdata?.UpfrontReqSDAmount : "",
            "securityDepositType": Securitydeptype ? Securitydeptype : "",
            "rc": userdata?.UpfrontReqRCAmount ? userdata?.UpfrontReqRCAmount : "",
            "modeOfPayment": selectPaymentMode?.value ? selectPaymentMode?.value : "",
            "paymentDate": selectedDate ? selectedDate : ""
          },
          "documentRequired": {
            "FirmType": selectedFirmType?.value ? selectedFirmType?.value : "",
            "aadharCard": false,
            "AadharNo": "",
            "aadharCardPhotoId": false,
            "bankPassbook": false,
            "centralStateGovtId": false,
            "centralStateGovtIdPhotoId": false,
            "creditCardStatement": false,
            "drivingLicense": false,
            "drivingLicenseNo": "",
            "drivingLicensePhotoId": false,
            "electricityBill": false,
            "gasConnection": false,
            "panCardPhotoId": true,
            "passport": false,
            "passportPhotoId": false,
            "PassportNo": "",
            "rationCardPhotoId": false,
            "rentAgreement": false,
            "telephoneBill": true,
            "votercard": false,
            "votercardPhotoId": false,
            "VoterNo": "",
            "waterBill": false,
            "telephoneIssueDate": "2025-01-08",
            "electricityIssueDate": "",
            "gasConnectionIssueDate": "",
            "waterBillIssueDate": "",
            "CompanyId": selectedCompany ? selectedCompany.value : "",
            "GroupId": selectedGroup ? selectedGroup.value : "",
            "RelationshipId": selectRelationship ? selectRelationship.value : "",
            "documentData": []
          },
          // "customerImage" : getNewCafUpdateRequestBody.customerImage,
          "customerImage": {
            fileNameWithExtension: getCustomerPicture?.fileNameWithExtension,
            fileContent: customerImg
          },
          "sellerImage": getNewCafUpdateRequestBody?.sellerImage,
          "customerKYCdocument": {
            customerKYCfileNameWithExtension: selectKycDoc,
            customerKYCAddress: "",
            customerKYCfileContent: getKycDocBase,
          },
          // "customerKYCdocument": getNewCafUpdateRequestBody?.customerKYCdocument,
          "lampLeadId": leadId,
          "lampCafId": CafId ? CafId : "",
          "userName": sessionStorage.getItem("userName"),
          "password": sessionStorage.getItem("password")
        }

        // Prepare request options
        const requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(postData),
        };

        // Make API call
        const response = await fetch(apiUrl, requestOptions);

        const data = await response.json();
        // console.log("data", data);

        // Handle API response
        if (data.Status === "Success") {
          toast.success("CAF Updated Successfully", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
          // navigate("/broadbandCaf");
        } else {
          toast.warning(data?.Response?.StatusName || "Update failed", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        }
      } catch (error) {
        console.error("Error sending data:", error.message);
        toast.error("An error occurred. Please try again.", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
      } finally {
        setLoading(false);
      }
    }
  };


  useEffect(() => {
    const fetchData = async () => {
      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
          "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          "Action": "getDedupeAlert",
          "userName": sessionStorage.getItem('userName'),
          "password": sessionStorage.getItem('password'),
          "CafSafNo": CafId ? CafId : ""
        }
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // "token": "e7e916c2e449f6306b27dea2fb2dde46",
          },
          body: JSON.stringify(requestData),
        });
        const data = await response.json();
        setDedupeDOAFlag(data.Response.DedupeDOAFlag)
      } catch (err) {
        console.error(err);
      }
    }

    fetchData()
  }, []);


  useEffect(() => {
    const fetchPaymentAlert = async () => {
      // console.log("getCafNo", CafId);
      try {
        const apiUrl = process.env.REACT_APP_API_URL_3;
        const requestData = {
          "Action": "getPaymentAlertDigi",
          "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          "userName": sessionStorage.getItem('userName'),
          "password": sessionStorage.getItem('password'),
          "CafSafNo": CafId ? CafId : ""
        }
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });
        const data = await response.json();
        setPaymentDOAFlag(data.Response.PaymentDOAFlag)
        // console.log("response", data.Response);
        // const datafetch = {
        //     "CafSafNo": "CAF_77820",
        //     "PaymentDOAFlag": "Yes",
        //     "StatusCode": 200,
        //     "Message": "Submit for approval as discount waiver added in the payment record."
        // }
        if (data.Response.PaymentDOAFlag == "Yes") {
          Swal.fire({
            // html: `<div style="font-size: 15px;">${data.Response.Message}</div>`,
            html: `<div style="font-size: 15px;">Submit for Appoval as Upfront Discount added</div>`,
            showCancelButton: true,
            confirmButtonText:
              '<span style="font-size: 12px;color:rgb(148,101,170);">Yes</span>',
            cancelButtonText:
              '<span style="font-size: 12px;color:rgb(148,101,170);">NO</span>',
            confirmButtonColor: "white",
            cancelButtonColor: "white",
            customClass: {
              popup: "custom-popup",
              confirmButton: "custom-confirm-button",
              cancelButton: "custom-cancel-button",
            },
          }).then(async (result) => {
            if (result.isConfirmed) {
              const { value: formValues } = await Swal.fire({
                title: `<div style="font-size: 15px;padding: 10px;">Enter Reason for Upfront Discount</div>`,
                // html: `<div style="font-size: 15px;">Reason of Payment DOA</div>`,
                html: `
                                    <input id="swal-input1" class="swal2-input">  `,
                focusConfirm: false,
                preConfirm: () => {
                  // return [document.getElementById("swal-input1").value];
                  const reason = document.getElementById("swal-input1").value.trim();
                  if (!reason) {
                    Swal.showValidationMessage("Reason is required.");
                    return;
                  }
                  return reason;
                }
              });
              if (formValues) {
                // Swal.fire(JSON.stringify(formValues));
                // console.log("formValues", formValues);
                try {
                  const apiUrl = process.env.REACT_APP_API_URL_3;
                  const requestData = {
                    "Action": "DOAForPaymentDigi",
                    "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    "userName": sessionStorage.getItem('userName'),
                    "password": sessionStorage.getItem('password'),
                    "CafSafNo": CafId,
                    "IsDOARequired": "Yes",
                    "ReasonForPaymentDOA": formValues
                  }
                  const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestData),
                  });
                  const data = await response.json();
                  if (data.Status == "Success") {
                    // try {
                    //   const apiUrl = process.env.REACT_APP_API_URL_3;
                    //   const requestData = {
                    //     "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    //     "Action": "getDedupeAlert",
                    //     "userName": sessionStorage.getItem('userName'),
                    //     "password": sessionStorage.getItem('password'),
                    //     "CafSafNo": CafId
                    //   }
                    //   const response = await fetch(apiUrl, {
                    //     method: "POST",
                    //     headers: {
                    //       "Content-Type": "application/json",
                    //       // "token": "e7e916c2e449f6306b27dea2fb2dde46",
                    //     },
                    //     body: JSON.stringify(requestData),
                    //   });
                    //   const data = await response.json();
                    //   setDedupeDOAFlag(data.Response.DedupeDOAFlag)
                    //   if (data.Response.DedupeDOAFlag == "Yes") {
                    //     Swal.fire({
                    //       // html: '<div style="font-size: 15px;">De-dupe case , Do you want to procced ?</div>',
                    //       html: `<div style="font-size: 15px;">${data.Response.Message}</div>`,
                    //       showCancelButton: true,
                    //       confirmButtonText:
                    //         '<span style="font-size: 12px;color:rgb(148,101,170);">Procced</span>',
                    //       cancelButtonText:
                    //         '<span style="font-size: 12px;color:rgb(148,101,170);">NO</span>',
                    //       confirmButtonColor: "white",
                    //       cancelButtonColor: "white",
                    //       customClass: {
                    //         popup: "custom-popup",
                    //         confirmButton: "custom-confirm-button",
                    //         cancelButton: "custom-cancel-button",
                    //       },
                    //     }).then(async (result) => {
                    //       if (result.isConfirmed) {
                    //         try {
                    //           const apiUrl = process.env.REACT_APP_API_URL_3;
                    //           const requestData = {
                    //             Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    //             Action: "DOAForDedupeAlert",
                    //             userName: sessionStorage.getItem('userName'),
                    //             password: sessionStorage.getItem('password'),
                    //             CafSafNo: CafId,
                    //             IsDOARequired: "Yes",
                    //           };

                    //           const response = await fetch(apiUrl, {
                    //             method: "POST",
                    //             headers: {
                    //               "Content-Type": "application/json",
                    //             },
                    //             body: JSON.stringify(requestData),
                    //           });

                    //           if (!response.ok) {
                    //             throw new Error(`HTTP error! status: ${response.status}`);
                    //           }

                    //           const data = await response.json();
                    //           // console.log("API Response:", data);

                    //         } catch (error) {
                    //           console.error("Error during API call:", error.message);
                    //         }
                    //       }
                    //       else if ((result.dismiss === Swal.DismissReason.cancel)) {
                    //         Swal.fire({
                    //           html: '<div style="font-size: 15px;">Are you sure?</div>',
                    //           // html: `<div style="font-size: 15px;">${data.Response.Message}</div>`,
                    //           showCancelButton: true,
                    //           confirmButtonText:
                    //             '<span style="font-size: 12px;color:rgb(148,101,170);">yes</span>',
                    //           cancelButtonText:
                    //             '<span style="font-size: 12px;color:rgb(148,101,170);">No</span>',
                    //           confirmButtonColor: "white",
                    //           cancelButtonColor: "white",
                    //           customClass: {
                    //             popup: "custom-popup",
                    //             confirmButton: "custom-confirm-button",
                    //             cancelButton: "custom-cancel-button",
                    //           },
                    //         }).then(async (result) => {
                    //           if (result.isConfirmed) {
                    //             try {
                    //               const apiUrl = process.env.REACT_APP_API_URL_3;
                    //               const requestData = {
                    //                 Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    //                 Action: "DOAForDedupeAlert",
                    //                 userName: sessionStorage.getItem('userName'),
                    //                 password: sessionStorage.getItem('password'),
                    //                 CafSafNo: CafId,
                    //                 IsDOARequired: "No",
                    //               };

                    //               const response = await fetch(apiUrl, {
                    //                 method: "POST",
                    //                 headers: {
                    //                   "Content-Type": "application/json",
                    //                 },
                    //                 body: JSON.stringify(requestData),
                    //               });

                    //               if (!response.ok) {
                    //                 throw new Error(`HTTP error! status: ${response.status}`);
                    //               }
                    //               const data = await response.json();
                    //               // console.log("API Response:", data);

                    //               if (data.Response.StatusCode == "200") {
                    //                 navigate("/broadbandCAF");
                    //               }
                    //             } catch (error) {
                    //               console.error("Error during API call:", error.message);
                    //             }
                    //           }
                    //         });
                    //         // try {
                    //         //   const apiUrl = process.env.REACT_APP_API_URL_3;
                    //         //   const requestData = {
                    //         //     Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    //         //     Action: "DOAForDedupeAlert",
                    //         //     userName: sessionStorage.getItem('userName'),
                    //         //     password: sessionStorage.getItem('password'),
                    //         //     CafSafNo: CafId,
                    //         //     IsDOARequired: "No",
                    //         //   };

                    //         //   const response = await fetch(apiUrl, {
                    //         //     method: "POST",
                    //         //     headers: {
                    //         //       "Content-Type": "application/json",
                    //         //     },
                    //         //     body: JSON.stringify(requestData),
                    //         //   });

                    //         //   if (!response.ok) {
                    //         //     throw new Error(`HTTP error! status: ${response.status}`);
                    //         //   }
                    //         //   const data = await response.json();
                    //         //   console.log("API Response:", data);

                    //         //   if (data.Response.StatusCode == "200") {
                    //         //     navigate("/broadbandCAF");
                    //         //   }
                    //         // } catch (error) {
                    //         //   console.error("Error during API call:", error.message);
                    //         // }
                    //       }
                    //     })
                    //   }
                    // } catch (error) {
                    //   console.error("Error fetching data:", error.message);
                    // }

                    try {
                      const apiUrl = process.env.REACT_APP_API_URL_3;
                      const requestData = {
                        "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                        "Action": "getDedupeAlert",
                        "userName": sessionStorage.getItem('userName'),
                        "password": sessionStorage.getItem('password'),
                        "CafSafNo": CafId
                      }
                      const response = await fetch(apiUrl, {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                          // "token": "e7e916c2e449f6306b27dea2fb2dde46",
                        },
                        body: JSON.stringify(requestData),
                      });
                      const data = await response.json();
                      setDedupeDOAFlag(data.Response.DedupeDOAFlag)
                      if (data.Response.DedupeDOAFlag == "Yes") {

                        try {
                          const apiUrl = process.env.REACT_APP_API_URL_3;
                          const requestData = {
                            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                            Action: "DOAForDedupeAlert",
                            userName: sessionStorage.getItem('userName'),
                            password: sessionStorage.getItem('password'),
                            CafSafNo: CafId,
                            IsDOARequired: "Yes",
                          };

                          const response = await fetch(apiUrl, {
                            method: "POST",
                            headers: {
                              "Content-Type": "application/json",
                            },
                            body: JSON.stringify(requestData),
                          });

                          if (!response.ok) {
                            throw new Error(`HTTP error! status: ${response.status}`);
                          }

                          const data = await response.json();
                          // console.log("API Response:", data);
                          if (data.Response.StatusCode == 200) {
                            toast.success(data.Response.Message, {
                              position: toast.POSITION.BOTTOM_CENTER,
                              autoClose: 1500,
                            });
                          } else {
                            toast.warning(data.Response.Message, {
                              position: toast.POSITION.BOTTOM_CENTER,
                              autoClose: 1500,
                            });
                          }

                        } catch (error) {
                          console.error("Error during API call:", error.message);
                        }

                      }
                    } catch (error) {
                      console.error("Error fetching data:", error.message);
                    }
                  } else {
                    toast.warning(data.Response.Message, {
                      position: toast.POSITION.BOTTOM_CENTER,
                      autoClose: 1500,
                    });
                  }
                } catch (error) {
                  console.error("Error fetching data:", error.message);
                }
              }
            } else if ((result.dismiss === Swal.DismissReason.cancel)) {
              try {
                const apiUrl = process.env.REACT_APP_API_URL_3;
                const requestData = {
                  "Action": "DOAForPaymentDigi",
                  "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                  "userName": sessionStorage.getItem('userName'),
                  "password": sessionStorage.getItem('password'),
                  "CafSafNo": CafId,
                  "IsDOARequired": "No",
                  "ReasonForPaymentDOA": ""
                }
                const response = await fetch(apiUrl, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(requestData),
                });
                const data = await response.json();
                if (data.Status == "Success") {
                  navigate("/broadbandCAF");
                }
              } catch (error) {
                console.error("Error fetching data:", error.message);
              }
            }
          });
        }
      } catch (error) {
        console.error("Error fetching data:", error.message);
      }
    };
    fetchPaymentAlert();
  }, []);


  // DOAForDedupeAlert logic megha
  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const apiUrl = process.env.REACT_APP_API_URL;
  //       const requestData = {
  //         "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
  //         "Action": "getDedupeAlert",
  //         "userName": sessionStorage.getItem('userName'),
  //         "password": sessionStorage.getItem('password'),
  //         "CafSafNo": CafId ? CafId : ""
  //       }
  //       const response = await fetch(apiUrl, {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //           // "token": "e7e916c2e449f6306b27dea2fb2dde46",
  //         },
  //         body: JSON.stringify(requestData),
  //       });
  //       const data = await response.json();
  //       if (data.Response.DedupeDOAFlag == "Yes") {
  //         Swal.fire({
  //           // html: '<div style="font-size: 15px;">De-dupe case , Do you want to procced ?</div>',
  //           html: `<div style="font-size: 15px;">${data.Response.Message}</div>`,
  //           showCancelButton: true,
  //           confirmButtonText:
  //             '<span style="font-size: 12px;color:rgb(148,101,170);">Procced</span>',
  //           cancelButtonText:
  //             '<span style="font-size: 12px;color:rgb(148,101,170);">NO</span>',
  //           confirmButtonColor: "white",
  //           cancelButtonColor: "white",
  //           customClass: {
  //             popup: "custom-popup",
  //             confirmButton: "custom-confirm-button",
  //             cancelButton: "custom-cancel-button",
  //           },
  //         }).then(async (result) => {
  //           if (result.isConfirmed) {
  //             try {
  //               const apiUrl = process.env.REACT_APP_API_URL;
  //               const requestData = {
  //                 Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
  //                 Action: "DOAForDedupeAlert",
  //                 userName: sessionStorage.getItem('userName'),
  //                 password: sessionStorage.getItem('password'),
  //                 CafSafNo: CafId ? CafId : "",
  //                 IsDOARequired: "Yes",
  //               };

  //               const response = await fetch(apiUrl, {
  //                 method: "POST",
  //                 headers: {
  //                   "Content-Type": "application/json",
  //                 },
  //                 body: JSON.stringify(requestData),
  //               });

  //               if (!response.ok) {
  //                 throw new Error(`HTTP error! status: ${response.status}`);
  //               }

  //               const data = await response.json();
  //               console.log("API Response:", data);

  //             } catch (error) {
  //               console.error("Error during API call:", error.message);
  //             }
  //           }
  //           else if ((result.dismiss === Swal.DismissReason.cancel)) {
  //             Swal.fire({
  //               html: '<div style="font-size: 15px;">Are You Sure?</div>',
  //               // html: `<div style="font-size: 15px;">${data.Response.Message}</div>`,
  //               showCancelButton: true,
  //               confirmButtonText:
  //                 '<span style="font-size: 12px;color:rgb(148,101,170);">yes</span>',
  //               cancelButtonText:
  //                 '<span style="font-size: 12px;color:rgb(148,101,170);">No</span>',
  //               confirmButtonColor: "white",
  //               cancelButtonColor: "white",
  //               customClass: {
  //                 popup: "custom-popup",
  //                 confirmButton: "custom-confirm-button",
  //                 cancelButton: "custom-cancel-button",
  //               },
  //             }).then(async (result) => {
  //               if (result.isConfirmed) {
  //                 try {
  //                   const apiUrl = process.env.REACT_APP_API_URL_3;
  //                   const requestData = {
  //                     Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
  //                     Action: "DOAForDedupeAlert",
  //                     userName: sessionStorage.getItem('userName'),
  //                     password: sessionStorage.getItem('password'),
  //                     CafSafNo: CafId ? CafId : "",
  //                     IsDOARequired: "No",
  //                   };

  //                   const response = await fetch(apiUrl, {
  //                     method: "POST",
  //                     headers: {
  //                       "Content-Type": "application/json",
  //                     },
  //                     body: JSON.stringify(requestData),
  //                   });

  //                   if (!response.ok) {
  //                     throw new Error(`HTTP error! status: ${response.status}`);
  //                   }
  //                   const data = await response.json();
  //                   console.log("API Response:", data);

  //                   if (data.Response.StatusCode == "200") {
  //                     navigate("/broadbandCAF");
  //                   }
  //                 } catch (error) {
  //                   console.error("Error during API call:", error.message);
  //                 }
  //               }
  //             });

  //           }
  //         })
  //       }
  //     } catch (error) {
  //       console.error("Error fetching data:", error.message);
  //     }
  //   };
  //   fetchData();
  // }, []);





  // ****************API'S****************//


  // useEffect(() => {
  //   const fetchBroadBandLead = async () => {
  //     try {
  //       const apiUrl = process.env.REACT_APP_API_URL_1;
  //       const requestData = {
  //         Action: "getleads",
  //         Authkey: "AdgT6SnjAkeLqlkE4",
  //         leadId: leadId,
  //         password: sessionStorage.getItem("password"),
  //         userName: sessionStorage.getItem("userName"),
  //       };

  //       const response = await fetch(apiUrl, {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify(requestData),
  //       });

  //       if (!response.ok) {
  //         throw new Error(`HTTP error! Status: ${response.status}`);
  //       }
  //       setLoading(false);
  //       const result = await response.json();
  //       setLeadDisable(true);

  //       setSalutate(result.Response[0].SalutationId);
  //       setFirstName(result.Response[0].Companyname);
  //       setMobileNo(result.Response[0].MobileNo);
  //       setEmailId(result.Response[0].EmailId);
  //       const filterfirmType = firmtypeOpts.find((item) => item.value === String(result.Response[0].companyDetail.FirmType)).label;
  //       setSelectedFirmType({
  //         label: filterfirmType,
  //         value: result.Response[0].companyDetail.FirmType,
  //       });
  //       setSelectRelationship(result.Response[0].RelationshipId);




  //       setApiFloorCode(result.Response[0].installationAddress.InstallFloor);
  //       setApiPinCode(result.Response[0].installationAddress.InstallPincode);
  //       setApiblockCode(result.Response[0].installationAddress.InstallPlotNo);
  //       // console.log("PRODNFDJD", result.Response[0].ProductName)
  //       // setApiProd(result.Response[0].ProductName)
  //       const OtpAuthStaus = result.Response[0].OTPAuthStatsu;
  //       const boolean = OtpAuthStaus.toString();
  //       setotpAuthStatus(boolean);
  //       setCheckboxes(result.Response[0].documentRequired);


  //       setPaymentDetails(result.Response[0].paymentDetail);
  //       selectPaymentMode(result.Response[0].paymentDetail.PayInSlip);
  //       // console.log("paty", result.Response[0].paymentDetail.PayInSlip);
  //       // console.log("wqeqw", result.Response[0]);
  //     } catch (error) {
  //       console.error("Error fetching data:", error.message);
  //     }
  //   };
  //   if (!CafId) {
  //     fetchBroadBandLead();
  //   }
  // }, []);



  useEffect(() => {
    const fetchGetProduct = async () => {
      try {
        setLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
          Action: "getProductlist",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          oppid: sessionStorage.getItem('opportunityId'),
          reason: "",
          siteId: "",
          password: sessionStorage.getItem('password'),
          userName: sessionStorage.getItem('userName'),
        };

        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });
        const result = await response.json();
        // console.log("result.Response:", result.Response.Data);

        if (result.Response && Array.isArray(result.Response.Data)) {

          const transformedOptions = result.Response.Data.map(
            (option) => ({
              label: option.ProductId,
              value: option.ProductCode,
            })
          );
          setProductdropdetails(transformedOptions);
        } else {
          console.error(
            "product data structure not recognized:",
            result.Response
          );
          setProductdropdetails([]);
        }

      } catch (error) {
        console.error("Error fetching data:", error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchGetProduct();
  }, []);





  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        // console.log(searchParams.get("LeadId"));
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestBody = {
          Action: "getopportunity",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          LeadId: searchParams.get("LeadId") || "",
          OppId: OppId ? OppId : "",
          password: sessionStorage.getItem('password'),
          userName: sessionStorage.getItem('userName'),
        };
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        });
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const responsedata = await response.json();
        // console.log("responsedata: ", responsedata);
        const responseData = responsedata?.Response?.Data?.[0];
        if (responsedata?.Status === "Success" && responseData) {
          setCustomerImg(responseData?.customerImage?.FileContent);
          const concatenatedAddress = `${responseData.BlockTowerNumber || ''} ${responseData.HousePlotFlatNo || ''} ${responseData.SocietyName || ''} ${responseData.Area || ''} ${responseData.City || ''} ${responseData.State || ''} ${responseData.Country || ''}`;
          setUserData({
            Remarks: responseData?.Remarks || "",
            Redunancy: responseData?.Redunancy || false,
            Block: responseData?.Block || "",
            Status: responseData?.Status || "",
            Statuscode: responseData?.Statuscode || "",
            OppId: responseData?.OppId || "",
            LeadId: responseData?.LeadId || "",
            PriceList: responseData?.PriceList || "",
            Topic: responseData?.Topic || "",
            StateId: responseData?.StateId || "",
            CityId: responseData?.CityId || "",
            AreaId: responseData?.AreaId || "",
            BuildingId: responseData?.BuildingId || "",
            SpecificArea: responseData?.SpecificArea || "",
            SpecificBuilding: responseData?.SpecificBuilding || "",
            Building_BuildingStatus: responseData?.Building_BuildingStatus || "",
            NoOfUsers: responseData?.NoOfUsers || "",
            NoOfBeds: responseData?.NoOfBeds || "",
            ApprovalRequiredFlag: responseData?.ApprovalRequiredFlag || "",
            Reason: responseData?.Reason || "",
            Area: responseData?.Area || "",
            Subbusinesssegment: responseData?.Subbusinesssegment || "",
            Businesssegment: responseData?.Businesssegment || "",
            State: responseData?.State || "",
            Salutation: responseData?.Salutation || "",
            PostalCode: responseData?.PostalCode || "",
            Mobilephone: responseData?.Mobilephone || "",
            Media: responseData?.Media || "",
            Lco: responseData?.Lco || null,
            Group: responseData?.Group || "",
            Floor: responseData?.Floor || "",
            TPFeasibilty: responseData?.TPFeasibilty || "",
            CreateAreaOrBuilding: responseData?.CreateAreaOrBuilding || false,
            Firmtype: responseData?.Firmtype || "",
            ProductSegment: responseData?.ProductSegment || "",
            FeasibilityRequired: responseData?.FeasibilityRequired || false,
            Existingprovider: responseData?.Existingprovider || "",
            Emailaddress: responseData?.Emailaddress || "",
            Country: responseData?.Country || "",
            Companyname: responseData?.Companyname || "",
            City: responseData?.City || "",
            leadname: responseData?.leadname || "",
            Buildingname: responseData?.Buildingname || "",
            BuildingNo: responseData?.BuildingNo || "",
            ContactPerson: responseData?.ContactPerson || "",
            CustomerSegment: responseData?.CustomerSegment || "",
            LastMileType: responseData?.LastMileType || "",
            UpTimesla: responseData?.UpTimesla || "",
            Firewall: responseData?.Firewall || "",
            CompanySelf: responseData?.CompanySelf || "",
            PoLock: responseData?.PoLock || "",
            Price: responseData?.Price || "",
            OriginatingLead: responseData?.OriginatingLead || "",
            FirewallAwc: responseData?.FirewallAwc || "",
            PoNext: responseData?.PoNext || "",
            Company: responseData?.Company || "",
            TotalAmount: responseData?.TotalAmount || "",
            VerticalID: responseData?.VerticalID || "",
            TypeOfOrder: responseData?.TypeOfOrder || "",
            PocClosureDate: responseData?.PocClosureDate || "",
            TurnOver: responseData?.TurnOver || "",
            SocietyName: responseData?.SocietyName || "",
            SocietyId: responseData?.SocietyId || "",
            SocietyStatus: responseData?.SocietyStatus || "",
            HousePlotFlatNo: responseData?.HousePlotFlatNo || "",
            BlockTowerNumber: responseData?.BlockTowerNumber || "",
            OTCAmount: responseData?.OTCAmount || "",
            SDAmount: responseData?.SDAmount || "",
            RCAmount: responseData?.RCAmount || "",
            IsPaymentLinkSendToCustomer: "",
            UpfrontApprovedSDAmount: "",
            UpfrontApprovedOTCAmount: "",
            UpfrontApprovedRCAmount: "",
            UpfrontReqSDAmount: "",
            UpfrontReqOTCAmount: "",
            UpfrontReqRCAmount: "",
            ApprovedSDAmount: responseData?.ApprovedSDAmount || "",
            ApprovedOTCAmount: responseData?.ApprovedOTCAmountIncTax || "",
            ApprovedRCAmount: responseData?.ApprovedRCAmountIncTax || "",
            totalAmount: responseData?.TotalAmount || "",
          });

          setSalutate(responseData?.Salutation);
          setMobileNo(responseData?.Mobilephone);
          setEmailId(responseData?.Emailaddress);
          setApiFloorCode(responseData?.HousePlotFlatNo);
          setApiPinCode(responseData?.PostalCode);
          setApiblockCode(responseData?.BlockTowerNumber);
          setFloor(responseData?.Floor);
          fetchLatLong(concatenatedAddress);
          setFirstName(responseData?.Companyname);
          setCustomerPicture({ fileNameWithExtension: responseData?.customerImage?.FileNameWithExtension });




          // let leadName = responseData?.leadname || "";

          // let leadName = "DEV IT private LIMITED private limited";

          // console.log("leadName 1", leadName);

          // if (leadName) {
          //   let words = leadName.trim().split(" ");
          //   let seen = new Set();
          //   let uniqueWords = [];

          // Keep only the first occurrence of each word (case insensitive)
          // for (let word of words) {
          //   let lowerWord = word.toLowerCase(); // Convert to lowercase for comparison
          //   if (!seen.has(lowerWord)) {
          //     seen.add(lowerWord);
          //     uniqueWords.push(word); // Keep original casing
          //   }
          // }

          //   leadName = uniqueWords.join(" ");
          // }

          // console.log("leadName 2", leadName);
          // setLeadName(leadName);



          setLeadName(responseData?.leadname);

          setSelectIndustry({
            value: responseData?.IndustryId,
            label: responseData?.Industry,
          })

          setSelectedProductType({
            value: responseData?.ProductId,
            label: responseData?.Product,
          });

          setSelectState({
            value: responseData?.StateId,
            label: responseData?.State
          })

          setSelectCity({
            value: responseData?.CityId,
            label: responseData?.City
          })



          setSelectArea({
            value: responseData?.AreaId,
            label: responseData?.Area
          })

          setSelectSociety({
            value: responseData?.SocietyId,
            label: responseData?.SocietyName
          })



          try {
            const companyRequestBody = {
              Action: "getCompany",
              Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
              companyId: "New Company",
              password: sessionStorage.getItem("password"),
              userName: sessionStorage.getItem("userName"),
            };

            const companyResponse = await fetch(apiUrl, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(companyRequestBody),
            });

            const companyData = await companyResponse.json();
            if (companyData?.Status === "Success" && companyData?.StatusCode === "200") {
              const companyOptions = companyData.Response.Data.map((company) => ({
                label: company.Company_Name,
                value: company.Company_ID,
                group: company.Group_Name,
                groupId: company.Group_ID,
              }));
              const filterCompany = companyOptions?.find(
                (item) => item.label.trim() === responseData.Company.trim()
              );
              if (filterCompany) {
                setSelectedCompany({
                  value: filterCompany?.value || "",
                  label: filterCompany?.label || "",
                });
                setSelectedGroup({
                  value: filterCompany?.groupId || "",
                  label: filterCompany?.group || "",
                });
              }
              if (filterCompany.value) {
                const relationshipOptions1 = await fetchRelationshipData(
                  filterCompany.value
                );
                // console.log("relationshipOptions1",relationshipOptions1);
                const filterRelation = relationshipOptions1.find(
                  (item) => item.label.trim() == responseData.Relationship.trim()
                );
                // console.log("filterRelation",filterRelation);
                setSelectRelationship({
                  value: filterRelation?.value || "",
                  label: filterRelation?.label || "",
                });
              }
            }
          } catch (error) {
            console.error("Error fetching company data:", error);
          }


        } else {
          // Handle unsuccessful response
          console.error("Error fetching opportunity data:", responseData?.Message);
        }
      } catch (error) {
        // Handle fetch error
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [getLeadId]);



  useEffect(() => {
    const fetchBussinessCAF = async () => {
      try {
        if (!CafId) return; // Ensure CafId is present before calling the API

        const apiUrl = process.env.REACT_APP_API_URL_2;

        const requestData = {
          Action: "getCafDigiHome",
          Authkey: "AdgT6SnjAkeLqlkE4",
          CAFId: CafId,
          password: sessionStorage.getItem("password"),
          userName: sessionStorage.getItem("userName"),
        };
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });
        const result = await response.json();
        if (result.Status === "Success" && result.Response) {
          const { accountDetail, paymentDetail, documentRequired, cafDetail, authorSigDetails } = result?.Response;
          // console.log(cafDetail);

          setCaflatitude(cafDetail.latitude);
          setCaflongitude(cafDetail.longitude);
          setPaymentButton(result.Response.paymentDetail.IsPaymentLinkSendToCustomer);
          sessionStorage.setItem("firmtype", documentRequired?.FirmType ? documentRequired?.FirmType : "");
          setCustomerImg(result.Response.customerImage?.FileContent);
          setFloor(result.Response?.Floor);
          setSalutate(accountDetail?.SalutationId || "");
          setFirstName(accountDetail?.FirstName || "");
          setLastName(accountDetail?.LastName || "");
          setMobileNo(cafDetail?.MobileNo);
          setEmailId(result?.Response?.accountDetail?.EmailId);
          setBillingEmailId(result?.Response?.cafDetail?.BillingEmailID);
          setTechSupportEmailId(result?.Response?.cafDetail?.TechnicalSupportEmailID);
          setGender(result?.Response?.cafDetail?.Gender);
          setVoice(result?.Response?.cafDetail?.Voice);
          setCustomerPicture({ fileNameWithExtension: result?.Response?.customerImage?.FileNameWithExtension });
          setSellerPicture({ sellerFileNameWithExtension: result?.Response?.cafDetail?.sellerImage?.SellerFileNameWithExtension })
          // console.log("hgj",result?.Response?.cafDetail?.sellerImage?.SellerFileNameWithExtension);

          setSelectKycDoc(result?.Response?.cafDetail?.customerKYCdocument?.CustomerKYCfileNameWithExtension);
          setGetKycDocBase(result?.Response?.cafDetail?.customerKYCdocument?.SellerFileContent)
          setApiFloorCode(result?.Response?.cafDetail?.HousePlotFlatNumber);
          setApiPinCode(result?.Response?.cafDetail?.PostalCode);
          setApiblockCode(result?.Response?.accountDetail?.BlockTower);
          setSelectIndustry({
            value: cafDetail?.IndustryId || "",
            label: cafDetail?.IndustryType || "",
          });

          const filterFirmType = firmtypeOpts.find((item) => item.value === String(documentRequired?.FirmType));
          setSelectedFirmType(filterFirmType ? { value: documentRequired?.FirmType, label: filterFirmType.label } : null);





          setSelectedProductType({
            value: cafDetail?.Product,
            label: cafDetail?.ProductName,
          });
          setSelectPaymentMode({
            value: result?.Response?.paymentDetail?.ModeOfPayment,
            label: result?.Response?.paymentDetail?.ModeOfPayment,
          });
          const filterpaymentStatus = PaymentOpts?.find((item) => item.value === String(result?.Response?.paymentDetail?.PaymentStatus)).label;
          setpaymentStatus({
            label: filterpaymentStatus,
            value: result?.Response?.paymentDetail?.PaymentStatus,
          })


          setselectedPaySlipOption(result?.Response?.paymentDetail?.PayInSlip);
          setPaymentDetails(result?.Response?.paymentDetail);
          setSecuritydep(paymentDetail?.SecurityDeposit);
          // setIsGst(result.Response.cafDetail.IsGST);
          setchequeDDNo(result?.Response?.paymentDetail?.ChequeDDNo);
          setbranchName(result?.Response?.paymentDetail?.BranchName);

          // setselectBank(BankDropDetails.find((data) => data.value == result.Response.paymentDetail.BankName)); 

          // setTan(result?.Response?.cafDetail?.TANNo);
          // setPan(result?.Response?.cafDetail?.PANNo);
          setSecuritydeptype(paymentDetails?.SecurityDepositType);
          setIsPaymentLinkSendToCustomer(paymentDetail?.IsPaymentLinkSendToCustomer);


          setUserData({
            totalAmount: paymentDetail?.Amount ? paymentDetail?.Amount : "",
            OTCAmount: paymentDetail?.OTCAmount ? paymentDetail?.OTCAmount : "",
            SDAmount: paymentDetail?.SDAmount ? paymentDetail?.SDAmount : "",
            RCAmount: paymentDetail?.RCAmount ? paymentDetail?.RCAmount : "",
            IsPaymentLinkSendToCustomer: paymentDetail?.IsPaymentLinkSendToCustomer || "",
            UpfrontApprovedSDAmount: paymentDetail?.UpfrontApprovedSDAmount || "",
            UpfrontApprovedOTCAmount: paymentDetail?.UpfrontApprovedOTCAmount || "",
            UpfrontApprovedRCAmount: paymentDetail?.UpfrontApprovedRCAmount || "",
            UpfrontReqSDAmount: paymentDetail?.UpfrontRequestedSDAmount || "",
            UpfrontReqOTCAmount: paymentDetail?.UpfrontRequestedOTCAmountIncTax || "",
            UpfrontReqRCAmount: paymentDetail?.UpfrontRequestedRCAmountIncTax || "",
            ApprovedSDAmount: paymentDetail?.ApprovedSDAmount || "",
            ApprovedOTCAmount: paymentDetail?.ApprovedOTCAmountIncTax || "",
            ApprovedRCAmount: paymentDetail?.ApprovedRCAmountIncTax || "",
            dDupStatus: cafDetail?.DedupeDOAstatus ? cafDetail?.DedupeDOAstatus : "",
            paymentDoaStatus: cafDetail?.paymentDOAstatus ? cafDetail?.paymentDOAstatus : "",
            authName: authorSigDetails ? authorSigDetails?.AuthName : "",
            authFatherName: authorSigDetails ? authorSigDetails?.AuthFatherORhusbandName : "",
            authResidentialAdd: authorSigDetails ? authorSigDetails?.AuthResidentialAddress : "",
            authMobile: authorSigDetails ? authorSigDetails?.AuthMobileNumber : "",
            authPhone: authorSigDetails ? authorSigDetails?.AuthMobileNumber : "",
            authEmail: authorSigDetails ? authorSigDetails?.AuthEmailID : "",
            authPinCode: authorSigDetails ? authorSigDetails?.AuthpostalCode : "",
            PanNo: result?.Response?.cafDetail?.PanNo,
            TanNo: result?.Response?.cafDetail?.TanNo,
            GstNumber: result?.Response?.cafDetail?.GstNumber,

            ProfessionofSubscriber: result?.Response?.cafDetail?.ProfessionofSubscriber || "",
            DOBorDateofRegistration: result?.Response?.cafDetail?.DOBorDateofRegistration || ""
          });




          const filterAuthState = optionAuthState.find(
            (item) => item.code === String(authorSigDetails?.Authstate)
          ).name;
          // console.log("filterAuthState", optionAuthState);

          setSelectAuthState({
            label: filterAuthState,
            value: authorSigDetails?.Authstate,
          });
          // setSelectAuthCity(cityAuthOption.find((data) => data.value == result?.Response?.authorSigDetails.Authcity)); 


          let selectedBankId = result?.Response?.paymentDetail?.BankName;
          try {
            const apiUrl = process.env.REACT_APP_API_URL;
            const requestData = {
              Action: "getBank",
              Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
              cafNo: CafId,
              oppid: "",
              safNo: "",
              password: sessionStorage.getItem("password"),
              userName: sessionStorage.getItem("userName"),
            };
            const response = await fetch(apiUrl, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(requestData),
            });
            const result = await response.json();
            if (result.Response.StatusCode == 200) {
              const bankdata = result?.Response?.Data.map(
                (option) => ({
                  label: option.Bankname,
                  value: option.BankId,
                })
              );
              // console.log("bankdata",bankdata); 
              // setBankDropDetails(bankdata);

              const filterSelectBank = bankdata?.find((item) => item.value === selectedBankId);
              if (filterSelectBank) {
                setselectBank({
                  label: filterSelectBank.label,
                  value: selectedBankId,
                });
              }
            }
          } catch (error) {
            console.error("Error fetching data:", error.message);
          }

          let SelectedAuthCity = authorSigDetails?.Authcity;
          let SelectedCity = accountDetail?.City;
          try {
            // City API call
            const cityApiUrl = process.env.REACT_APP_API_URL;
            const cityRequestBody = {
              Action: "getCity",
              Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
              password: sessionStorage.getItem('password'),
              stateCode: selectAuthState.value,
              userName: sessionStorage.getItem('userName'),
            };
            const cityResponse = await fetch(cityApiUrl, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(cityRequestBody),
            });
            const cityData = await cityResponse.json();

            if (cityData?.Response && Array.isArray(cityData?.Response?.Data)) {
              const transformedOptions = cityData?.Response?.Data.map(
                (option) => ({
                  label: option?.CityName,
                  value: option?.CityCode,
                })
              );
              // setCityAuthOption(transformedOptions);
              const filterCity = transformedOptions?.find((data) => data.value == authorSigDetails?.Authcity)
              setSelectAuthCity({
                label: filterCity?.label,
                value: SelectedAuthCity,
              });
              const filterCityOne = transformedOptions?.find((data) => data.value == accountDetail?.City)
              setSelectCity({
                label: filterCityOne?.label,
                value: SelectedCity,
              })

              try {
                const areaApiUrl = process.env.REACT_APP_API_URL_2;
                const areaRequestBody = {
                  Action: "getarea",
                  Authkey: "AdgT6SnjAkeLqlkE4",
                  cityCode: SelectedCity,
                  cityName: filterCityOne?.label,
                  password: sessionStorage.getItem("password"),
                  restrictedarea: true,
                  stateCode: "",
                  userName: sessionStorage.getItem("userName"),
                };
                const areaResponse = await fetch(areaApiUrl, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(areaRequestBody),
                });
                const areaData = await areaResponse.json();
                if (areaData.Response && Array.isArray(areaData.Response)) {
                  // console.log("area :", areaData.Response);
                  // setAreaList(areaData.Response);
                  const area = areaData?.Response;

                  const filterArea = area?.find(
                    (item) => item?.AreaCode.includes(accountDetail?.Area.trim())
                  );
                  // console.log("filterArea",filterArea);
                  setSelectArea({
                    label: filterArea?.AreaName,
                    value: accountDetail?.Area,
                  })

                  try {
                    const societyApiUrl = process.env.REACT_APP_API_URL_2;
                    const societyRequestBody = {
                      Action: "getsociety",
                      Authkey: "AdgT6SnjAkeLqlkE4",
                      areaCode: accountDetail?.Area,
                      password: sessionStorage.getItem("password"),
                      userName: sessionStorage.getItem("userName"),
                    };
                    const societyResponse = await fetch(societyApiUrl, {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                      },
                      body: JSON.stringify(societyRequestBody),
                    });
                    const societyData = await societyResponse.json();
                    // console.log("societyData.Response", societyData.Response);
                    if (societyData.Response && Array.isArray(societyData.Response)) {
                      // setSocietyList(societyData.Response);
                      const society = societyData.Response || [];
                      // console.log("societyData.Response", society);
                      const filterSociety = society.find(
                        (item) => item.SocietyCode.includes(accountDetail?.Society.trim())
                      );
                      // console.log("filterSociety", filterSociety);

                      setSelectSociety({
                        label: filterSociety.SocietyName,
                        value: accountDetail?.Society,
                      })
                    }
                  } catch (error) {
                    console.error("Error fetching area data:", error);
                  }
                }
              } catch (error) {
                console.error("Error fetching area data:", error);
              }
            }
          } catch (error) {
            console.error("Error fetching data:", error);
          }


          let relationshipOptions1
          let companyOption1
          if (accountDetail.CompanyId) {
            relationshipOptions1 = await fetchRelationshipData(
              accountDetail.CompanyId
            );
            // console.log("relationshipOptions1",relationshipOptions1);
            setRelationshipOptions(relationshipOptions1);
            companyOption1 = await fetchCompanyData(
              accountDetail?.CompanyId
            )
            setCompanyOptions(companyOption1)
          }
          // console.log("companyOption1", companyOption1);
          const compId = accountDetail?.CompanyId;
          const GroupId = accountDetail?.GroupId;

          const filterCompanyId = companyOption1 ? companyOption1?.find(item => String(item.value) === String(compId)) : null;
          // console.log("filterRelationshipId",filterRelationshipId);
          const filterGroupId = companyOption1 ? companyOption1?.find(item => String(item.groupId) === String(GroupId)) : null;
          if (filterCompanyId) {
            setSelectedCompany({
              value: filterCompanyId ? filterCompanyId?.value : "",
              label: filterCompanyId ? filterCompanyId?.label : "",
            });
            setSelectedGroup({
              value: filterGroupId ? filterGroupId?.groupId : "",
              label: filterGroupId ? filterGroupId?.group : "",
            });
          } else {
            console.error("RelationshipId not found in relationshipOptions");
          }


          const relationshipId = accountDetail?.RelationshipId;
          const filterRelationshipId = relationshipOptions1 ? relationshipOptions1?.find(item => String(item.value) === String(relationshipId)) : null;
          // console.log("filterRelationshipId",filterRelationshipId.label);
          if (filterRelationshipId) {
            setSelectRelationship({
              value: filterRelationshipId ? filterRelationshipId?.value : "",
              label: filterRelationshipId ? filterRelationshipId?.label : "",
            });
          } else {
            console.error("RelationshipId not found in relationshipOptions");
          }


          const filterState = optionAuthState.find(
            (item) => item.code === String(accountDetail?.State)
          ).name;
          // console.log("filterAuthState", optionAuthState);

          setSelectState({
            label: filterState,
            value: accountDetail?.State,
          });

          let KycDocName = (result?.Response?.cafDetail?.customerKYCdocument?.CustomerKYCfileNameWithExtension).split("_").pop().split(".")[0];
          // console.log(KycDocName);        
          setSelectDocument(optionDocument.find((data) => data.label == KycDocName))


          setCafDigiHome(result.Response);
        }
      } catch (error) {
        console.error("Error fetching data:", error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBussinessCAF();
  }, [CafId]);



  useEffect(() => {
    const fetchGetBank = async () => {
      try {
        setLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL;

        const requestData = {
          Action: "getBank",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          cafNo: CafId,
          oppid: "",
          safNo: "",
          password: sessionStorage.getItem("password"),
          userName: sessionStorage.getItem("userName"),
        };

        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const result = await response.json();

        // console.log("API Response bank:", result);
        if (result.Response.StatusCode == 200) {
          const bankdata = result?.Response?.Data.map(
            (option) => ({
              label: option.Bankname,
              value: option.BankId,
            })
          );
          // console.log("bankdata",bankdata);

          setBankDropDetails(bankdata);
        }

        // console.log("Bank", result.Response);
      } catch (error) {
        console.error("Error fetching data:", error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchGetBank();
  }, []);





  const handleSendPaymentLink = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestBody =
      {
        Action: "sendPaymentLinkToCustomer",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        userName: sessionStorage.getItem('userName'),
        password: sessionStorage.getItem('password'),
        cafSafNo: CafId,
        sendPaymentLink: "Yes"
      }
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      const responsedata = await response.json();
      // console.log("responsedata", responsedata);
      if (responsedata.Response.StatusCode == 200) {
        toast.success(responsedata.Response.Message, {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
      }

    } catch (error) {
      // Handle fetch error
      console.error("Error fetching data:", error);
    }
  }


  const manageDocClick = () => {
    navigate(`/broadbandCAFmangeNewDoc?CafId=${CafId}`);
  };



  return (
    <>
      {/* ***********Header********* */}
      <div className="container-fluid text-light Header-style header">
        <div className="p-3">
          <span
            className=""
            style={{ cursor: "pointer" }}
            onClick={redirectBroadbandCafPage}
          >
            <i className="fa-solid fa-arrow-left-long"></i>
          </span>
          <span className="p-1 m-3">Broadband CAF</span>
          {/* {!statusNoCaf && (
            <button
              type="download"
              className="btn text-dark  mx-auto cstm-handler"
            >
              <i className="fa-solid fa-download"></i> Download
            </button>
          )} */}
        </div>
      </div>
      {/* ************Header end************ */}

      {loading && (
        <div className="loader-wrapper">
          <div className="loader">
            <img src={loader} alt="loading...."></img>
          </div>
        </div>
      )}

      <div className="container-fluid form-container">
        {/* **************Customer Details toggle******************* */}
        <div
          className="contact-toggle"
          onClick={() => handleIconClick("form1")}
        >
          <span className="toggle-text">Customer Details</span>
          <span className=" float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>

        {activeForm === "form1" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form1"
          >
            {/* *********Customer Details form******** */}

            <form className="contact-form p-2">

              <div className="">
                <label className="select-search-label mt-1">
                  Salutation*
                </label>
                <Select
                  className=" basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  placeholder="Select Option"
                  id="ssss"
                  name="salutation"
                  value={SalutationOpts.find(
                    (option) => option.value == (salutate || getCafDigiHome?.accountDetail?.SalutationId)
                  )}
                  onChange={handleSAlutation}
                  options={SalutationOpts}
                  styles={style}
                  isSearchable={true}
                />
              </div>

              {!CafId &&
                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className="form-control input-text form-control-sm mt-1"
                    id="leadname"
                    name="leadname"
                    value={leadName}
                    onChange={handleCustomerdetailChange}
                    style={{ background: "transparent" }}
                    readOnly
                  />
                  <label htmlFor="floatingInput" className="mt-2">Lead Name</label>
                </div>}

              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="firstName"
                  name="firstName"
                  value={firstName}
                  onChange={handleCustomerdetailChange}
                  style={{ background: "transparent" }}
                />
                <label htmlFor="floatingInput" className="mt-2">First Name</label>
              </div>


              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="lastName"
                  name="lastName"
                  value={lastName}
                  onChange={handleCustomerdetailChange}
                  style={{ background: "transparent" }}
                />
                <label htmlFor="floatingInput" className="mt-2">Last Name</label>
              </div>

              <div className="">
                <label className="select-search-label mt-1">
                  Gender*
                </label>
                <Select
                  className=" basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  placeholder="Select Option"
                  id="ssss"
                  name="gender"
                  value={genderOptions.find(
                    (option) => option.value == (gender || getCafDigiHome?.cafDetail?.Gender)
                  )}
                  onChange={handleGender}
                  options={genderOptions}
                  styles={style}
                  isSearchable={true}
                />
              </div>

              <div className="input-box form-floating ">
                <input
                  type="tel"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="CAF"
                  name="mobileNo"
                  maxLength="10"
                  pattern="[0-9]{10}"
                  value={mobileNo}
                  onChange={handleCustomerdetailChange}

                />

                <label htmlFor="floatingInput" className="mt-2">
                  Mobile No.
                </label>
              </div>
              <div className="input-box form-floating ">
                <input
                  type="text"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="emailId"
                  name="emailId"
                  value={emailId}
                  onChange={handleCustomerdetailChange}
                />

                <label htmlFor="floatingInput" className="mt-2">
                  Email Id
                </label>
              </div>

              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="gstNo"
                  name="ProfessionofSubscriber"
                  value={userdata?.ProfessionofSubscriber || ""}
                  onChange={handleChange}
                  // disabled={disableFileds}
                  style={{ background: "transparent" }}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Profession of Subscriber
                </label>
              </div>

              <div className="input-box form-floating">
                <input
                  type="date"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="DOBorDateofRegistration"
                  name="DOBorDateofRegistration"
                  value={yyyymmddFormat(userdata?.DOBorDateofRegistration) || ""}
                  onChange={handleChange}
                  // disabled={disableFileds}
                  style={{ background: "transparent" }}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  DOB/Date of registration
                </label>
              </div>

              <div className="input-box form-floating ">
                <input
                  type="text"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="techSupportEmail"
                  name="billingEmailId"
                  value={billingEmailId}
                  onChange={handleCustomerdetailChange}
                />

                <label htmlFor="floatingInput" className="mt-2">
                  Billing Email ID*
                </label>
              </div>

              <div className="input-box form-floating ">
                <input
                  type="text"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="techSupportEmail"
                  name="techSupportEmail"
                  // value={techSupportEmail}
                  value={techSupportEmail}
                  onChange={handleCustomerdetailChange}
                />

                <label htmlFor="floatingInput" className="mt-2">
                  Technical Support Email ID*
                </label>
              </div>



              {CafId &&
                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className="form-control input-text form-control-sm mt-1"
                    id="Company"
                    name="cafNo"
                    value={CafId}
                    // disabled={disableFileds || leadDisable}
                    disabled={true}
                    style={{ background: "transparent" }}
                    onChange={handleCustomerdetailChange}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    CAF No.
                  </label>
                </div>}

              <div className="input-box form-floating ">
                <input
                  type="text"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="voice"
                  name="voice"
                  value={Voice}
                  // disabled={disableFileds || leadDisable}

                  style={{ background: "transparent" }}
                  onChange={handleCustomerdetailChange}
                  readOnly
                />

                <label htmlFor="floatingInput" className="mt-2">
                  Voice
                </label>
              </div>

              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="gstNo"
                  name="gstNo"
                  value={userdata?.gstNo || ""}
                  onChange={handleChange}
                  // disabled={disableFileds}
                  style={{ background: "transparent" }}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  GST Number
                </label>
              </div>

              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="panNo"
                  name="panNo"
                  value={userdata?.panNo || ""}
                  onChange={handleChange}
                  // disabled={disableFileds}
                  style={{ background: "transparent" }}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  PAN Number
                </label>
              </div>

              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="tanNo"
                  name="tanNo"
                  value={userdata?.tanNo || ""}
                  onChange={handleChange}
                  // disabled={disableFileds}
                  style={{ background: "transparent" }}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  TAN Number
                </label>
              </div>

              <div>
                <div
                  className="input-box form-floating"
                  style={{ position: "relative" }}
                >
                  <input
                    id="cameraFileInputCustomer"
                    type="file"
                    accept="image/*"
                    capture="camera"
                    onChange={handleFileChangeCustomer}
                    style={{ display: "none" }}
                  />
                  <input
                    type="text"
                    placeholder=""
                    className="form-control input-text form-control-sm mt-1"
                    id="picture"
                    name="livePicture"
                    value={getCustomerPicture.fileNameWithExtension}
                    accept="image/*"
                    capture="camera"
                    style={{ background: "transparent" }}
                    onClick={OpenCameraCustomer}
                    readOnly
                  />
                  <i
                    className="fa-solid fa-paperclip fa-paper-icon fa-locator"
                    onClick={OpenCameraCustomer}
                  ></i>
                  <label htmlFor="floatingInput" className="paperclip mt-2">
                    Customer Live Picture*
                  </label>
                </div>

                {/* ============ Validate Customer Live Picture ============= */}
                {userName2?.toLowerCase() == "manager1" && getCustomerImageStatus != null && (
                  <div>
                    {(getCustomerImageStatus?.status == "success") ? (
                      <div className="d-flex align-items-center text-sm text-gray-500">
                        <div className="form-control-sm" style={{ fontSize: "12px", fontWeight: "400" }}>
                          Image validated Successfully
                        </div>
                        <span className="text-success" >
                          <i className="fas fa-check-circle"></i>
                        </span>
                      </div>
                    ) : (
                      <div className="" style={{ opacity: ".70", fontSize: "14px", fontWeight: "300" }}>
                        {/* Guidelines note */}
                        <div className="d-flex align-items-center text-sm text-gray-500 mb-0">
                          <div className="form-control-sm text-danger" style={{ fontSize: "12px", fontWeight: "400" }}>
                            Note: Please follow the guidelines and try again.
                          </div>
                        </div>
                        {/* White Background Check */}
                        <div className="d-flex align-items-center text-sm text-gray-500 mb-0">
                          <div className="form-control-sm" style={{ fontSize: "12px", fontWeight: "400" }}>
                            White Background Check
                          </div>
                          <span className={getCustomerImageStatus?.data?.white_background_check == "Pass" ? "text-success" : "text-danger"}>
                            <i className={getCustomerImageStatus?.data?.white_background_check == "Pass" ? "fas fa-check-circle" : "fas fa-times-circle"}></i>
                          </span>
                        </div>

                        {/* Face Presence & Framing Check */}
                        <div className="d-flex align-items-center text-sm text-gray-500">
                          <div className="form-control-sm" style={{ fontSize: "12px", fontWeight: "400" }}>
                            Face Presence & Framing Check
                          </div>
                          <span className={getCustomerImageStatus?.data?.face_presence_and_framing_check == "Pass" ? "text-success" : "text-danger"} >
                            <i className={getCustomerImageStatus?.data?.face_presence_and_framing_check == "Pass" ? "fas fa-check-circle" : "fas fa-times-circle"}></i>
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>

              {/* {console.log("getCustomerPicture.fileNameWithExtension",getCustomerPicture.fileNameWithExtension)} */}

              <div className="text-center">
                <div className="mt-3">OR</div>
              </div>

              <div className="container my-2">
                <div className="row justify-content-center">
                  <div className="col-12 col-md-3 text-center my-2">
                    <button
                      type="button"
                      className="btn btn-dark w-100 btn-sm rounded-pill"
                      onClick={SendLinkForCustomerLivePicture}
                      disabled={getCustomerPicture.fileNameWithExtension}
                    >
                      Send Link For Customer Live Picture
                    </button>
                  </div>
                </div>
              </div>

            </form>
          </div>
        )}



        <div
          className="wcr-toggle mt-3"
          onClick={() => handleIconClick("form2")}
        >
          <span className="toggle-text">Seller Self Identification</span>
          <span className=" float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>

        {activeForm === "form2" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form11"
          >
            {/* *********Seller Self Identification ******** */}
            <form className="contact-form p-2">

              <div className="input-box form-floating mb-3">
                <input
                  type="tel"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="otp"
                  name="otp"
                  maxLength="6"
                  pattern="[0-9]{10}"
                  value={userdata.otp}
                  onChange={handleChange}
                  onKeyDown={(e) => {
                    const allowedKeys = [
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                      "Tab",
                    ];
                    const isDigit = /\d/.test(e.key);
                    const sellerOtp = userdata.otp || "";
                    if (
                      isDigit ||
                      allowedKeys.includes(e.key) ||
                      (sellerOtp.length < 6 && e.key === "Backspace")
                    ) {
                      return true;
                    } else {
                      e.preventDefault();
                    }
                  }}

                />
                <label htmlFor="floatingInput" className="mt-2">
                  Self Authentication Code*
                </label>

                {/* {console.log("userdata.otp",userdata.otp)}  */}

                {isOtpVerified !== null && (
                  <span
                    className={`position-absolute ${isOtpVerified ? "text-success" : "text-danger"}`}
                    style={{ top: "50%", right: "10px", transform: "translateY(-50%)" }}
                  >
                    <i className={isOtpVerified ? "fas fa-check-circle" : "fas fa-times-circle"}></i>
                  </span>
                )}
              </div>

              <div
                className="input-box form-floating"
                style={{ position: "relative" }}
              >
                <input
                  id="cameraFileInputSeller"
                  type="file"
                  accept="image/*"
                  capture="camera"
                  onChange={handleFileChangeSeller}
                  style={{ display: "none" }}
                // disabled={true}
                />
                <input
                  type="text"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="picture"
                  name="picture"
                  value={getSellerPicture.sellerFileNameWithExtension}
                  accept="image/*"
                  capture="camera"
                  style={{ background: "transparent" }}
                  onClick={OpenCameraSeller}
                  disabled={!isOtpVerified}
                  readOnly
                />
                <i
                  className="fa-solid fa-paperclip fa-paper-icon fa-locator"
                  onClick={OpenCameraSeller}
                ></i>
                <label htmlFor="floatingInput" className="paperclip mt-2">
                  Seller Live Picture*
                </label>
              </div>



              <div className="container my-4">
                <div className="row justify-content-center">
                  {/* Send/Resend Code Button */}
                  <div className="col-12 col-md-3 text-center my-2">
                    <button
                      type="button"
                      className="btn btn-dark w-100 rounded-pill"
                      onClick={handleSendOtp}
                      disabled={isOtpVerified || isTimerActive} // Disable the button during the timer
                    >
                      {isTimerActive ? `Resend Code in ${timer}s` : getCodeFlag ? "Resend Code" : "Send Code"}
                    </button>
                  </div>

                  {/* Submit Code Button */}
                  <div className="col-12 col-md-3 text-center my-2">
                    <button
                      type="button"
                      className="btn btn-dark w-100 rounded-pill"
                      onClick={handleVerifyOtp}
                      disabled={!getCodeFlag || isOtpVerified}
                    >
                      Submit Code
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        )}



        <div
          className="wcr-toggle mt-3"
          onClick={() => handleIconClick("form3")}
        >
          <span className="toggle-text">KYC Verification</span>
          <span className="float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>

        {activeForm === "form3" && (
          <div
            className="container shadow mb-3 bg-body rounded mt-4"
            id="form12"
          >
            <form className="contact-form p-2">

              <div className="">
                <label className="select-search-label mt-1">
                  Select Document Type*
                </label>
                <Select
                  className=" basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  name="Document"
                  placeholder="Select Document Type"
                  styles={style}
                  value={selectDocument}
                  isSearchable={false}
                  onChange={handleSelectFile}
                  options={optionDocument.map((data) => ({
                    value: data.value,
                    label: data.label,
                  }))}
                  // disabled={CafId}
                  isDisabled={CafId || kycDocStatus === "Success"}
                />
              </div>

              <div className="input-box form-floating mt-3" style={{ position: "relative" }}>
                <input
                  id="kycdoc"
                  type="file"
                  accept="image/*,application/pdf"
                  capture="environment"
                  onChange={handleFileChangekycDocOCR}
                  style={{ display: "none" }}
                />
                <input
                  type="text"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="picture"
                  name="picture"
                  disabled={CafId || kycDocStatus === "Success"}
                  // value={getNewCafUpdateRequestBody?.customerKYCdocument?.customerKYCfileNameWithExtension}
                  value={selectKycDoc}
                  style={{ background: "transparent" }}
                  onClick={() => document.getElementById("kycdoc").click()}
                  readOnly
                />
                {kycDocStatus == "Success" ? <i className="fa-solid fa-check fa-paper-icon fa-locator" style={{ color: "#77c171" }} ></i> :
                  <i
                    className="fa-solid fa-paperclip fa-paper-icon fa-locator"
                    onClick={() => document.getElementById("kycdoc").click()}
                  ></i>}
                <label htmlFor="floatingInput" className="paperclip mt-2">
                  KYC Document*
                </label>
              </div>





            </form>
          </div>
        )}


        {/* *********Installation Addresss toggle******** */}

        <div
          className="installation-toggle mt-3"
          onClick={() => handleIconClick("form4")}
        >
          <span className="toggle-text">Installation Address</span>
          <span className=" float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>

        {activeForm === "form4" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form2"
          >
            {/* *********Installation Addresss form******** */}
            <form className=" contact-form p-2">

              <div className="">
                <label className="select-search-label mt-1">Company*</label>
                <Select
                  className="basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  name="company"
                  value={selectedCompany}
                  onChange={handleCompanyChange}
                  options={companyOptions}
                  styles={style}
                  isSearchable={true}
                  isLoading={loader}
                  placeholder="Select Company"
                  isDisabled={CafId}
                />
              </div>

              {/* {console.log("companyOptions",companyOptions)} */}


              <div className="">
                <label className="select-search-label mt-1">Group*</label>
                <Select
                  className="basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  name="group"
                  placeholder="Select Group"
                  value={selectedGroup}
                  onChange={handleGroupChange}
                  options={groupOptions}
                  styles={style}
                  isSearchable={true}
                  isLoading={loader}
                  isDisabled={CafId}
                />
              </div>

              <div className="">
                <label className="select-search-label mt-1">
                  Relationship*
                </label>
                <Select
                  className="basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  name="group"
                  value={selectRelationship ? selectRelationship : ""}
                  onChange={handleSelectRelationship}
                  options={relationshipOptions ? relationshipOptions : ""}
                  styles={style}
                  isSearchable={true}
                  isLoading={loader}
                  placeholder="Select Relationship"
                  isDisabled={CafId}
                />
              </div>


              <div className="">
                <label className="select-search-label mt-1">State*</label>
                <Select
                  className=" basic-single form-control form-control form-control-sm p-1"
                  classNamePrefix="select"
                  name="state"
                  placeholder="Select State"
                  isSearchable={false}
                  styles={style}
                  value={selectState}
                  onChange={handleSelectState}
                  options={optionState.map((data) => ({
                    value: data.code,
                    label: data.name,
                  }))}
                />
              </div>

              <div className="">
                <label className="select-search-label mt-1">City*</label>
                <Select
                  className="basic-single form-control form-control form-control-sm p-1"
                  classNamePrefix="select"
                  name="City"
                  placeholder="Select City"
                  isSearchable={false}
                  styles={style}
                  // value={cityType.find(
                  //   (city) => city.CityCode === selectCity.value
                  // )}
                  value={selectCity}
                  onChange={handleSelectCity}
                  options={cityType.map((data) => ({
                    value: data.CityCode,
                    label: data.CityName,
                  }))}
                />
              </div>

              <div className="">
                <label className="select-search-label mt-1">Area*</label>
                <Select
                  options={areaList?.map((area) => ({
                    value: area.AreaCode,
                    label: `${area.AreaName} (${area.AreaCode})`,
                  }))}
                  className="basic-single  form-control form-control-sm p-1"
                  placeholder="Search Area"
                  styles={style}
                  isSearchable
                  value={selectArea}
                  onChange={handleSelectArea}
                />
              </div>



              <div className="">
                <label className="select-search-label mt-1">Building/Society*</label>
                <Select
                  className="basic-single form-control form-control form-control-sm p-1"
                  classNamePrefix="select"
                  name="Society"
                  placeholder="Select Society"
                  isSearchable
                  styles={style}
                  value={selectSociety}
                  onChange={handleSelectSociety}
                  options={societyList?.map((data) => ({
                    value: data.SocietyCode,
                    label: data.SocietyName,
                  }))}
                />
              </div>




              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="apiFloorCode"
                  name="apiFloorCode"
                  value={apiFloorCode}
                  onChange={handleFloorChange}
                />

                <label htmlFor="floatingInput" className="mt-2">
                  House/Plot/Flat Number*
                </label>
              </div>



              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="apiblockCode"
                  name="apiblockCode"
                  value={apiblockCode}
                  onChange={handleBlockChange}
                />

                <label htmlFor="floatingInput" className="mt-2">
                  Block/Tower No.*
                </label>
              </div>

              <div
                className="input-box form-floating"
                style={{ position: "relative", paddingTop: "4px" }}
              >
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="floor"
                  name="floor"
                  value={floor}
                  // readOnly={true}
                  style={{ background: "transparent" }}
                  onChange={handleFloor}
                />
                <label htmlFor="floatingInput">Floor*</label>
              </div>
              {/* {console.log("floor",floor)} */}


              <div className="input-box form-floating ">
                <input
                  type="tel"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="apipinCode"
                  name="apipinCode"
                  value={apipinCode}
                  maxLength="6"
                  pattern="[0-9]{10}"
                  onChange={handlePinChange}
                  onKeyDown={(e) => {
                    const allowedKeys = [
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                      "Tab",
                    ];
                    const isDigit = /\d/.test(e.key);
                    if (
                      (isDigit || allowedKeys.includes(e.key)) &&
                      (apipinCode.length < 6 || e.key === "Backspace")
                    ) {
                      return true;
                    } else {
                      e.preventDefault();
                    }
                  }}
                />

                <label htmlFor="floatingInput" className="mt-2">
                  Pin Code*
                </label>
              </div>
            </form>
          </div>
        )}


        {/* *********Authorised Signatory Details******** */}

        <div
          className="wcr-toggle mt-3"
          onClick={() => handleIconClick("form5")}
        >
          <span className="toggle-text">Authorised Signatory Details</span>
          <span className=" float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>

        {activeForm === "form5" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form3"
          >
            {/* *********Authorised Signatory form******** */}
            <form className=" contact-form p-2">
              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="authName"
                  name="authName"
                  value={userdata.authName}
                  onChange={handleChange}
                  style={{ background: "transparent" }}

                />
                <label htmlFor="floatingInput" className="mt-2">Name</label>
              </div>


              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="authFatherName"
                  name="authFatherName"
                  value={userdata.authFatherName}
                  onChange={handleChange}
                  style={{ background: "transparent" }}

                />
                <label htmlFor="floatingInput" className="mt-2">Father's/Husband's Name</label>
              </div>

              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="authResidentialAdd"
                  name="authResidentialAdd"
                  value={userdata.authResidentialAdd}
                  onChange={handleChange}
                  style={{ background: "transparent" }}

                />
                <label htmlFor="floatingInput" className="mt-2">Residantial Address</label>
              </div>

              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="authMobile"
                  name="authMobile"
                  value={userdata.authMobile}
                  onChange={handleChange}
                  style={{ background: "transparent" }}

                  onKeyDown={(e) => {
                    const allowedKeys = [
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                      "Tab",
                    ];
                    const mobileNumber = userdata.authMobile || "";

                    const isDigit = /\d/.test(e.key);
                    if (
                      (isDigit || allowedKeys.includes(e.key)) &&
                      (mobileNumber.length < 10 ||
                        e.key === "Backspace")
                    ) {
                      return true;
                    } else {
                      e.preventDefault();
                    }
                  }}
                />
                <label htmlFor="floatingInput" className="mt-2">Mobile Number</label>
              </div>

              {/* <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="authPhone"
                  name="authPhone"
                  value={userdata.authPhone}
                  onChange={handleChange}
                  style={{ background: "transparent" }}
                  disabled={disableFileds}
                  onKeyDown={(e) => {
                    const allowedKeys = [
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                      "Tab",
                    ];
                    const phoneNumber = userdata.authPhone || "";
                    const isDigit = /\d/.test(e.key);
                    if (
                      (isDigit || allowedKeys.includes(e.key)) &&
                      (phoneNumber.length < 10 ||
                        e.key === "Backspace")
                    ) {
                      return true;
                    } else {
                      e.preventDefault();
                    }
                  }}
                />
                <label htmlFor="floatingInput" className="mt-2">Phone Number</label>
              </div> */}


              <div className="input-box form-floating">
                <input
                  type="email"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="authEmail"
                  name="authEmail"
                  value={userdata.authEmail}
                  onChange={handleChange}
                  style={{ background: "transparent" }}
                />
                <label htmlFor="floatingInput" className="mt-2">Email Id</label>
              </div>


              <div className="">
                <label className="select-search-label mt-1">Country</label>
                <Select
                  className=" basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  name="IndustrySeg"
                  placeholder="Select Country"
                  styles={style}
                  isSearchable={false}
                  value={selectAuthCountry}
                  onChange={handleSelectAuthCountry}
                  options={optionCountry.map((data) => ({
                    value: data.value,
                    label: data.label,
                  }))}
                />
              </div>

              <div className="">
                <label className="select-search-label mt-1">State</label>
                <Select
                  className=" basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  name="IndustrySeg"
                  placeholder="Select State"
                  isSearchable={false}
                  styles={style}
                  value={selectAuthState}
                  onChange={handleSelectAuthState}
                  options={optionAuthState.map((data) => ({
                    value: data.code,
                    label: data.name,
                  }))}
                />
              </div>

              <div className="">
                <label className="select-search-label mt-1">City</label>
                <Select
                  className="basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  name="City"
                  placeholder="Select City"
                  isSearchable
                  styles={style}
                  value={selectAuthCity}
                  onChange={handleSelectAuthCity}
                  options={cityAuthOption.map((data) => ({
                    value: data.value,
                    label: data.label,
                  }))}
                />
              </div>






              <div className="input-box form-floating">
                <input
                  type="tel"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="authPinCode"
                  name="authPinCode"
                  value={userdata.authPinCode}
                  onChange={handleChange}
                  style={{ background: "transparent" }}
                  onKeyDown={(e) => {
                    const allowedKeys = [
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                      "Tab",
                    ];
                    const pinCode = userdata.authPinCode || "";
                    const isDigit = /\d/.test(e.key);
                    if (
                      (isDigit || allowedKeys.includes(e.key)) &&
                      (pinCode.length < 6 || e.key === "Backspace")
                    ) {
                      return true;
                    } else {
                      e.preventDefault();
                    }
                  }}
                />
                <label htmlFor="floatingInput" className="mt-2">Pin Code</label>
              </div>



            </form>
          </div>)}

        {/* *********Other Information toggle******** */}

        <div
          className="other-toggle mt-3"
          onClick={() => handleIconClick("form6")}
        >
          <span className="toggle-text">Product & Firm Type</span>
          <span className=" float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>

        {activeForm === "form6" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form3"
          >
            {/* *********Other Information form******** */}
            <form className=" contact-form p-2">

              {/* {console.log("selectIndustry",selectIndustry)} */}

              <div className="">
                <label className="select-search-label mt-1">
                  Industry Type*
                </label>
                <Select
                  className="basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  placeholder="Select Option"
                  id="IndustryType"
                  name="IndustryType"
                  styles={style}
                  value={selectIndustry}
                  // isDisabled={true}
                  onChange={handleIndustryChnage}
                  options={industrydropdetails.map((data) => ({
                    value: data.value,
                    label: data.label,
                  }))}

                />
              </div>

              {/* {console.log("selectedProductType", selectedProductType)} */}
              <div className="">
                <label className="select-search-label mt-1">
                  Product Type*
                </label>
                <Select
                  className="basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  id="ProductType"
                  name="ProductType"
                  placeholder="Select Product"
                  styles={style}
                  value={selectedProductType}
                  onChange={handleProductTypeChange}
                  // options={productdropdetails?.map((data) => ({
                  //   value: data.value,
                  //   label: data.label,
                  // }))}
                  options={Array.isArray(productdropdetails) ? productdropdetails.map((data) => ({
                    value: data.value,
                    label: data.label,
                  })) : []}
                />
              </div>


              {/* {console.log("selectedFirmType", selectedFirmType)} */}



              <div className="">
                <label className="select-search-label mt-1">Firm Type*</label>
                <Select
                  className=" basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  id="firmType"
                  placeholder="Select Option"
                  name="firmType"
                  styles={style}
                  value={selectedFirmType}
                  onChange={handleFirmTypeChange} // Define the change handler function
                  options={firmTypes.map((data) => ({
                    value: data.value,
                    label: data.label,
                  }))}
                // isDisabled = {disableFileds}
                />
              </div>

            </form>
          </div>
        )}

        {/* *********Payment Details  toggle******** */}

        <div
          className="paymentdetails-toggle mt-3"
          onClick={() => handleIconClick("form7")}
        >
          <span className="toggle-text">Payment Details</span>
          <span className=" float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>

        {activeForm === "form7" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form4"
          >
            {/* *********Payment Details  Form******** */}
            <form className="contact-form p-2">




              <div className="input-box form-floating ">
                <input
                  type="text"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="firstName"
                  name="ApprovedRCAmount"
                  value={String(userdata.ApprovedRCAmount)}
                  onChange={handleChange}
                  disabled={true}
                  style={{ background: "transparent" }}
                  onKeyDown={(e) => {
                    const allowedKeys = [
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                      "Tab",
                    ];
                    const isDigit = /\d/.test(e.key);
                    if (
                      (isDigit || allowedKeys.includes(e.key))
                      //   &&  (basePriceDis < 10 || e.key === "Backspace")
                    ) {
                      return true;
                    } else {
                      e.preventDefault();
                    }
                  }}
                />
                <label htmlFor="floatingInput cstm-otc" className="mt-2">
                  Approved RC Amount(Inc Tax)
                </label>
              </div>


              <div className="input-box form-floating ">
                <input
                  type="text"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="firstName"
                  name="UpfrontReqRCAmount"
                  value={String(userdata.UpfrontReqRCAmount) || ""}
                  onChange={handleChange}
                  disabled={isPaymentLinkSendToCustomer == "Yes"}
                  style={{ background: "transparent" }}
                  onKeyDown={(e) => {
                    const allowedKeys = [
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                      "Tab",
                    ];
                    const isDigit = /\d/.test(e.key);
                    if (
                      (isDigit || allowedKeys.includes(e.key))
                    ) {
                      return true;
                    } else {
                      e.preventDefault();
                    }
                  }}
                />
                <label htmlFor="floatingInput cstm-otc" className="mt-2 upfont-textStyle">
                  Upfront Requested RC Amount(Inc Tax)
                </label>
              </div>


              <div className="input-box form-floating ">
                <input
                  type="text"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="firstName"
                  name="UpfrontApprovedRCAmount"
                  value={userdata.UpfrontApprovedRCAmount}
                  onChange={handleChange}
                  disabled={true}
                  style={{ background: "transparent" }}
                />
                <label htmlFor="floatingInput cstm-otc" className="mt-2 upfont-textStyle">
                  Upfront Approved RC Amount(Inc Tax)
                </label>
              </div>



              <div className="input-box form-floating ">
                <input
                  type="text"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="firstName"
                  name="ApprovedOTCAmount"
                  value={String(userdata.ApprovedOTCAmount)}
                  // onChange={handleOTCChange}
                  disabled={true}
                  style={{ background: "transparent" }}
                  onKeyDown={(e) => {
                    const allowedKeys = [
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                      "Tab",
                    ];
                    const isDigit = /\d/.test(e.key);
                    if (
                      (isDigit || allowedKeys.includes(e.key))
                      //   &&  (basePriceDis < 10 || e.key === "Backspace")
                    ) {
                      return true;
                    } else {
                      e.preventDefault();
                    }
                  }}
                />
                <label htmlFor="floatingInput cstm-otc" className="mt-2 upfont-textStyle">
                  Approved OTC Amount(Inc Tax)
                </label>
              </div>


              <div className="input-box form-floating ">
                <input
                  type="text"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="firstName"
                  name="UpfrontReqOTCAmount"
                  value={String(userdata.UpfrontReqOTCAmount) || ""}
                  onChange={handleChange}
                  disabled={isPaymentLinkSendToCustomer == "Yes"}
                  style={{ background: "transparent" }}
                  onKeyDown={(e) => {
                    const allowedKeys = [
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                      "Tab",
                    ];
                    const isDigit = /\d/.test(e.key);
                    if (
                      (isDigit || allowedKeys.includes(e.key))
                    ) {
                      return true;
                    } else {
                      e.preventDefault();
                    }
                  }}
                />
                <label htmlFor="floatingInput cstm-otc" className="mt-2 upfont-textStyle">
                  Upfront Requested OTC Amount(Inc Tax)
                </label>
              </div>



              <div className="input-box form-floating ">
                <input
                  type="text"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="firstName"
                  name="UpfrontApprovedOTCAmount"
                  value={userdata.UpfrontApprovedOTCAmount}
                  onChange={handleChange}
                  disabled={true}
                  style={{ background: "transparent" }}
                />
                <label htmlFor="floatingInput cstm-otc" className="mt-2 upfont-textStyle">
                  Upfront Approved OTC Amount(Inc Tax)
                </label>
              </div>


              <div className="input-box form-floating ">
                <input
                  type="text"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="firstName"
                  name="ApprovedSDAmount"
                  value={userdata.ApprovedSDAmount}
                  onChange={handleChange}
                  disabled={true}
                  style={{ background: "transparent" }}
                  onKeyDown={(e) => {
                    const allowedKeys = [
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                      "Tab",
                    ];
                    const isDigit = /\d/.test(e.key);
                    if (
                      (isDigit || allowedKeys.includes(e.key))
                      //   &&  (basePriceDis < 10 || e.key === "Backspace")
                    ) {
                      return true;
                    } else {
                      e.preventDefault();
                    }
                  }}
                />
                <label htmlFor="floatingInput cstm-otc" className="mt-2">
                  Approved SD Amount
                </label>
              </div>



              <div className="input-box form-floating ">
                <input
                  type="text"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="firstName"
                  name="UpfrontReqSDAmount"
                  value={String(userdata.UpfrontReqSDAmount) || ""}
                  onChange={handleChange}
                  disabled={isPaymentLinkSendToCustomer == "Yes"}
                  style={{ background: "transparent" }}
                  onKeyDown={(e) => {
                    const allowedKeys = [
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                      "Tab",
                    ];
                    const isDigit = /\d/.test(e.key);
                    if (
                      (isDigit || allowedKeys.includes(e.key))
                    ) {
                      return true;
                    } else {
                      e.preventDefault();
                    }
                  }}
                />
                <label htmlFor="floatingInput cstm-otc" className="mt-2">
                  Upfront Requested SD Amount
                </label>
              </div>




              <div className="input-box form-floating ">
                <input
                  type="text"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="firstName"
                  name="UpfrontApprovedOTCAmount"
                  value={userdata.UpfrontApprovedSDAmount}
                  onChange={handleChange}
                  disabled={true}
                  style={{ background: "transparent" }}
                />
                <label htmlFor="floatingInput cstm-otc" className="mt-2">
                  Upfront Approved SD Amount
                </label>
              </div>




              {CafId &&
                <>
                  <div className="input-box form-floating ">
                    <input
                      type="text"
                      placeholder=""
                      className="form-control input-text form-control-sm mt-1"
                      id="firstName"
                      name="totalAmount"
                      value={userdata.totalAmount}
                      // onChange={handleOTCChange}
                      disabled={true}
                      style={{ background: "transparent" }}
                    />
                    <label htmlFor="floatingInput cstm-otc" className="mt-2">
                      Total Amount
                    </label>
                  </div>

                  {console.log("userdata.totalAmount", userdata.totalAmount)}


                  <div className="">
                    <label className="select-search-label mt-1">
                      Payment Mode*
                    </label>
                    <Select
                      className=" basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      name="PaymentMode"
                      placeholder="Select Option"
                      styles={style}
                      value={selectPaymentMode}
                      isSearchable={false}
                      onChange={handlePaymentMode}
                      options={optionPayment.map((data) => ({
                        value: data.value,
                        label: data.label,
                      }))}
                      isDisabled={paymentStatus.label == "Payment Received" || userdata.totalAmount == "0.0000" || userdata.totalAmount == "0"}
                    />
                  </div>

                  <div className="">
                    <label className="select-search-label mt-1">
                      Pay-In-Slip*
                    </label>
                    <Select
                      className=" basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      id="payslip"
                      name="payslipnethod"
                      placeholder="Select Option"
                      styles={style}
                      value={payslipOpts.find(
                        (option) => option.value == selectedPaySlipOption
                      )}
                      onChange={handlePaySlipChange}
                      // options={payslipOpts}
                      options={filteredPayslipOpts}
                      isDisabled={paymentStatus.label == "Payment Received" || userdata.totalAmount == "0.0000" || userdata.totalAmount == "0"}
                    />
                  </div>

                  {/* {console.log("selectedPaySlipOption", selectedPaySlipOption)} */}

                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder=""
                      className="form-control input-text form-control-sm mt-1"
                      id="firstName"
                      name="firstName"
                      value={userdata.paymentDoaStatus}
                      style={{ background: "transparent" }}
                      readOnly
                    />
                    <label htmlFor="floatingInput" className="mt-2">Upfront Approval Status</label>
                  </div>


                  {/* <div className="input-box form-floating">
                    <input
                      type="tel"
                      placeholder=""
                      className=" form-control input-text form-control-sm mt-1"
                      id="firstName"
                      name="firstName"
                      value={Securitydep}
                      onChange={handleSecurityDepo}
                      disabled={disableFileds}
                      maxLength="20"
                      pattern="[0-9]{10}"
                      style={{ background: "transparent" }}
                      onKeyDown={(e) => {
                        const allowedKeys = [
                          "Backspace",
                          "Delete",
                          "ArrowLeft",
                          "ArrowRight",
                          "Tab",
                        ];
                        const isDigit = /\d/.test(e.key);
                        if (
                          (isDigit || allowedKeys.includes(e.key)) &&
                          (Securitydep.length < 20 || e.key === "Backspace")
                        ) {
                          return true;
                        } else {
                          e.preventDefault();
                        }
                      }}
                    />
                    <label htmlFor="floatingInput" className="mt-2">Security Deposit*</label>
                  </div>

                  <div className="">
                    <label className="select-search-label mt-1">
                      Security Deposit Type*
                    </label>
                    <Select
                      className=" basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      placeholder="Select Option"
                      id="securityType"
                      name="securityType"
                      styles={style}
                      value={SecuritypeOpts.find(
                        (option) => option.value === Securitydeptype
                      )}
                      onChange={handleSecType}
                      options={SecuritypeOpts}
                      isDisabled={disableFileds}
                    />
                  </div> */}

                  {selectedPaySlipOption === "4" || selectedPaySlipOption === "5" || selectedPaySlipOption === "7" ||
                    selectedPaySlipOption === "8" || selectedPaySlipOption === "11" || selectedPaySlipOption === "12" ||
                    selectedPaySlipOption === "13" ? (
                    /* Render NEFT or RTGS section */
                    <div>
                      <div className="input-box form-floating">
                        <input
                          type="text"
                          placeholder=""
                          className="form-control input-text form-control-sm mt-1"
                          id="transactionReferenceID"
                          name="transactionReferenceID"
                          value={transactionrefid}
                          onChange={handleTransactionRefID}
                          disabled={paymentStatus.label == "Payment Received"}
                          style={{ background: "transparent" }}
                        />
                        <label htmlFor="transactionReferenceID" className="mt-2">
                          Transaction Reference ID*
                        </label>
                      </div>

                      <div className="input-box form-floating">
                        <input
                          type="date"
                          className=" form-control input-text form-control-sm mt-1"
                          id=""
                          name=""
                          value={selectedDate}
                          placeholder="Select Date"
                          onChange={handleDateChange}
                          // min={getCurrentDate()}
                          style={{ background: "transparent" }}
                          disabled={paymentStatus.label == "Payment Received"}

                        />
                        <label htmlFor="paymentDate" className="mt-2">Payment Date*</label>
                      </div>
                    </div>

                  ) : selectedPaySlipOption === "7" || selectedPaySlipOption === "8" ? (
                    /* Render Credit Card, Debit Card, Ezetap section */
                    <div>
                      <div className="input-box form-floating">
                        <input
                          type="date"
                          className=" form-control input-text form-control-sm mt-1"
                          id=""
                          name=""
                          placeholder="Select Date"
                          value={selectedDate}
                          onChange={handleDateChange}
                          // min={getCurrentDate()}
                          disabled={paymentStatus.label == "Payment Received"}
                          style={{ background: "transparent" }}
                        />
                        <label htmlFor="paymentDate" className="mt-2">Payment Date*</label>
                      </div>
                      <div className="input-box form-floating">
                        <input
                          type="text"
                          placeholder=""
                          className="form-control input-text form-control-sm mt-1"
                          id="transactionReferenceID"
                          name="transactionReferenceID"
                          value={transactionrefid}
                          onChange={handleTransactionRefID}
                          disabled={paymentStatus.label == "Payment Received"}
                          style={{ background: "transparent" }}
                        />
                        <label htmlFor="transactionReferenceID" className="mt-2">
                          Transaction Reference ID*
                        </label>
                      </div>

                      <div className="input-box form-floating">
                        <input
                          type="text"
                          placeholder=""
                          className="form-control input-text form-control-sm mt-1"
                          id="approvalCode"
                          name="approvalCode"
                          value={approvalCode}
                          onChange={handleApprovalCode}
                          disabled={paymentStatus.label == "Payment Received"}
                          style={{ background: "transparent" }}
                        />
                        <label htmlFor="approvalCode" className="mt-2">Approval Code*</label>
                      </div>

                      {selectedPaySlipOption === "7" && (
                        <div className="input-box form-floating">
                          <input
                            type="text"
                            placeholder=""
                            className="form-control input-text form-control-sm mt-1"
                            id="creditCardLast4Digits"
                            name="creditCardLast4Digits"
                            value={creditDetails}
                            onChange={handleCreditdetails}
                            disabled={paymentStatus.label == "Payment Received"}
                            style={{ background: "transparent" }}

                            pattern="[0-9]{10}"
                            maxLength="4"
                            onKeyDown={(e) => {
                              const allowedKeys = [
                                "Backspace",
                                "Delete",
                                "ArrowLeft",
                                "ArrowRight",
                                "Tab",
                              ];
                              const isDigit = /\d/.test(e.key);
                              if (
                                (isDigit || allowedKeys.includes(e.key)) &&
                                (creditDetails.length < 4 ||
                                  allowedKeys.includes(e.key))
                              ) {
                                return true;
                              } else {
                                e.preventDefault();
                              }
                            }}
                          />
                          <label htmlFor="creditCardLast4Digits" className="mt-2">
                            Card Last 4 Digit No*
                          </label>
                        </div>)}

                      {selectedPaySlipOption === "8" && (
                        <div className="input-box form-floating">
                          <input
                            type="text"
                            placeholder=""
                            className="form-control input-text form-control-sm mt-1"
                            id="creditCardLast4Digits"
                            name="creditCardLast4Digits"
                            value={debitDetails}
                            onChange={handleDebditdetails}
                            disabled={paymentStatus.label == "Payment Received"}
                            style={{ background: "transparent" }}
                          />
                          <label htmlFor="creditCardLast4Digits" className="mt-2">
                            Debit Card Last 4 Digit No.*
                          </label>
                        </div>
                      )}
                    </div>
                  ) : selectedPaySlipOption === "1" || selectedPaySlipOption === "2" || selectedPaySlipOption === "12" ? (
                    /* Render Cheque, DD, Ezetap Cheque section */
                    <div>
                      <div className="">
                        <label className="select-search-label mt-1">
                          Bank Name*
                        </label>
                        <Select
                          className=" basic-single form-control form-control-sm p-1"
                          classNamePrefix="select"
                          id="firstName"
                          name="firstName"
                          placeholder="Select Bank Name"
                          styles={style}
                          value={selectBank}
                          onChange={handleBankChange}
                          options={BankDropDetails.map((data) => ({
                            value: data.value,
                            label: data.label,
                          }))}
                          isDisabled={paymentStatus.label == "Payment Received"}
                        />
                      </div>
                      {console.log("selectBank", selectBank)}

                      <div className="input-box form-floating">
                        <input
                          type="text"
                          placeholder=""
                          className=" form-control input-text form-control-sm mt-1"
                          id=""
                          name=""
                          value={branchName}
                          onChange={handleBranchChange}
                          disabled={paymentStatus.label == "Payment Received"}
                          style={{ background: "transparent" }}
                        />
                        <label htmlFor="floatingInput" className="mt-2">Branch Name*</label>
                      </div>
                      {/* {console.log("branchName", branchName)} */}
                      <div className="input-box form-floating">
                        <input
                          type="text"
                          placeholder=""
                          className=" form-control input-text form-control-sm mt-1"
                          id="firstName"
                          name="firstName"
                          value={chequeDDNo}
                          onChange={handleChequeNo}
                          disabled={paymentStatus.label == "Payment Received"}
                          style={{ background: "transparent" }}
                        />
                        <label htmlFor="floatingInput" className="mt-2">Cheque/DD no.*</label>
                      </div>
                      <div className="input-box form-floating">
                        <input
                          type="date"
                          placeholder="Select Date"
                          className=" form-control input-text form-control-sm mt-1"
                          id="firstName"
                          name="firstName"
                          value={chequeDate}
                          onChange={handleChequeDate}
                          disabled={paymentStatus.label == "Payment Received"}
                          style={{ background: "transparent" }}
                        />
                        <label htmlFor="paymentDate" className="mt-2">Cheque/DD Date.*</label>
                      </div>
                    </div>
                  ) : null}







                  <div className="">
                    <label className="select-search-label mt-1">
                      Payment Status*
                    </label>
                    <Select
                      className=" basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      id="firstName"
                      name="firstName"
                      placeholder="Select Payment Status"
                      value={paymentStatus}
                      styles={style}
                      onChange={handlePaymentStatus}
                      options={PaymentOpts.map((data) => ({
                        value: data.value,
                        label: data.label,
                      }))}
                      isDisabled={true}
                    />
                  </div>



                  <div className="input-box form-floating ">
                    <input
                      type="text"
                      placeholder=""
                      className="form-control input-text form-control-sm mt-1"
                      id="firstName"
                      name="IsPaymentLinkSendToCustomer"
                      value={getCafDigiHome?.paymentDetail?.IsPaymentLinkSendToCustomer || "NA"}
                      onChange={handleChange}
                      disabled
                      style={{ background: "transparent" }}
                    />
                    <label htmlFor="floatingInput cstm-otc" className="mt-2">
                      Is Payment LinkSend To Customer
                    </label>
                  </div>



                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder=""
                      className="form-control input-text form-control-sm mt-1"
                      id="firstName"
                      name="firstName"
                      value={userdata.dDupStatus}
                      // onChange={handleGstNumber}

                      style={{ background: "transparent" }}
                      readOnly
                    />
                    <label htmlFor="floatingInput" className="mt-2">De-dupe Status </label>
                  </div>
                </>
              }


              {paymentButton === "Yes" && paymentStatus.label !== "Payment Received" && (
                <div className="text-center mt-5 mb-3">
                  <button
                    type="button"
                    className="btn text-light submit-btn bg-dark mx-auto rounded-pill"
                    onClick={handleSendPaymentLink}
                  >
                    Send payment link
                  </button>
                </div>
              )}


            </form>
          </div>
        )}


        {/* ********* Customer Additional Requirements ************ */}
        {/* <div
          className="paymentdetails-toggle mt-3"
          onClick={() => handleIconClick("form8")}
        >
          <span className="toggle-text">Customer Additional Requirements</span>
          <span className=" float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>

        {activeForm === "form8" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form8"
          >
         
            <form className="contact-form p-2">
              <div className="Network_req">Network Requirements :</div>
              <div className="" style={{ marginLeft: "30px" }}>
                <div className="remark-area">
                  <label htmlFor="floatingInput">Bandwidth Requirements</label>
                  <textarea
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm textarea"
                    id="bandwidthReq"
                    name="bandwidthReq"
                    value={userdata.bandwidthReq}
                    onChange={handleChange}
                  />
                </div>

                <div className="remark-area">
                  <label htmlFor="floatingInput">Desired Bandwidth (Mbps)</label>
                  <textarea
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm textarea"
                    id="desiredBandwidth"
                    name="desiredBandwidth"
                    value={userdata.desiredBandwidth}
                    onChange={handleChange}
                  />
                </div>

                <div className="remark-area">
                  <label htmlFor="floatingInput">Number of Concurrent Users</label>
                  <textarea
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm textarea"
                    id="NumberOfConcurrentUsers"
                    name="NumberOfConcurrentUsers"
                    value={userdata.NumberOfConcurrentUsers}
                    onChange={handleChange}
                  />
                </div>

                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className="form-control input-text form-control-sm mt-1"
                    id="peakUsage"
                    name="peakUsage"
                    value={userdata.peakUsage}
                    onChange={handleChange}
                    style={{ background: "transparent" }}
                  />
                  <label htmlFor="floatingInput" className="mt-2">Peak Usage Times</label>
                </div>
              </div>


              <div className="Network_req mt-2">Network Requirements :</div>
              <div className="" style={{ marginLeft: "30px" }}>
                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className="form-control input-text form-control-sm mt-1"
                    id="networkReq"
                    name="networkReq"
                    value={userdata.networkReq}
                    onChange={handleChange}
                    style={{ background: "transparent" }}
                  />
                 
                </div>
              </div>


              <div className="Network_req mt-2 mb-2">Specific Application Requirements :</div>
              <div className="" style={{ marginLeft: "30px" }}>

                <div className="remark-area">
                  <label htmlFor="floatingInput">List of Critical Websites ( if Any….for latency & routing purpose )</label>
                  <textarea
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm textarea"
                    id="criticalWeb"
                    name="criticalWeb"
                    value={userdata.criticalWeb}
                    onChange={handleChange}
                  />
                </div>

                <div className="remark-area">
                  <label htmlFor="floatingInput">Latency-Sensitive Applications ( VOIP, Trading, VPN , Video Conference etc.)</label>
                  <textarea
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm textarea"
                    id="latency"
                    name="latency"
                    value={userdata.latency}
                    onChange={handleChange}
                  />
                </div>
              </div>


              <div className="Network_req mt-2">Security Requirements :</div>
              <div className="" style={{ marginLeft: "30px" }}>
                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className="form-control input-text form-control-sm mt-1"
                    id="securityReq"
                    name="securityReq"
                    value={userdata.securityReq}
                    onChange={handleChange}
                    style={{ background: "transparent" }}
                  />
               
                </div>
              </div>


            </form>
          </div>


        )} */}

        {/* *********Document Details  toggle******** */}

        {CafId && (
          <div
            className="doc-toggle mt-3"
            // hidden={docHide}
            onClick={manageDocClick}
          >
            <span className="toggle-text">Order Documents</span>
            <span className="float-end">
              <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
            </span>
          </div>
        )}

        {/* *********POA/POI Details  toggle******** */}



        {/* *********OTP  Form******** */}
        {/* {otpAuthStatus === "false" && (
            <div
              className="check-toggle mt-3"
              onClick={() => handleIconClick("form8")}
            >
              <span className="toggle-text">OTP</span>
              <span className=" float-end">
                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
              </span>
            </div>
          )} */}

        {activeForm === "form8" && otpAuthStatus === "false" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form8"
          ></div>
        )}

        {otpAuthStatus === "false" && (
          <div className="text-center mb-3 mt-3">
            {/* {!showOtpPage ? (
              <button
                type="submit"
                className="btn text-light  bg-dark mx-auto rounded-pill submit-btn "
                onClick={handleVerifyOtpClick}
              >
                Verify OTP
              </button>
            ) : (
              renderOtpVerificationForm()
            )} */}
          </div>
        )}

        <div className=" " style={{ marginTop: "50px", marginBottom: "40px" }}>
          {CafId && (
            <div className="text-center">
              <button
                type="update"
                className="btn text-light submit-btn bg-dark mx-auto rounded-pill"
                onClick={handleUpdate}

              >
                Update
              </button>
            </div>
          )}

          {kycDocStatus === "Success" && !CafId && (
            <div className="text-center">
              <button
                type="submit"
                className="btn text-light bg-dark mx-auto submit-btn rounded-pill"
                onClick={handleSave}
              >
                Create
              </button>
            </div>
          )}

        </div>
      </div>

    </>
  );
};

export default BroadbandCAFmanageForm;
